{
	"F-is-a-wildcard-for-any-character": "'F' ist ein Platzhalter für \"any character\".",
	"_box": "box",
	"_boxes": "boxes",
	"_generic": "generic",
	"_generic-plural": "genericPlural",
	"_hub": "hub",
	"_hubs": "hubs",
	"about-commands": "Über Befehle",
	"about-events": "Über Ereignisse",
	"about-routing-table": "Über Routing-Tabellen",
	"access-point-name": "Access Point Name (APN)",
	"access-token": "Zugangstoken",
	"access-type": "Zugangsart",
	"access-type-is-remote": "Fernzugriff auf den Datenpunkt",
	"access-type-is-remote-help": "Wählen Sie Ja, damit der Datenpunkt an die Cloud gesendet werden oder der Wert des Datenpunkts aus der Cloud geschrieben werden kann. Die Werte sind immer im Lese- und Schreibzugriff im Gerät (lokal) verfügbar",
	"access-type-is-remote-hub": "Fernzugriff auf den Datenpunkt, wenn der Empfang aktiviert ist",
	"acknowledge-alert": "Meldung bestätigen",
	"acknowledged": "Bestätigt",
	"actions": "Aktionen",
	"activate": "Aktivieren",
	"activate-account": "Aktivieren Sie Ihr Konto hier",
	"activate-box-hub": "Aktiviere {box}",
	"activate-reception-property-data-60-minutes": "Aktivieren des Empfangs von Datenpunkt-Werten für 60 min.",
	"activation-method": "Aktivierungsmethode",
	"activation-method-tooltip": "Methode zur Aktivierung des Geräts (vom Hersteller bereitgestellt), normalerweise OTAA",
	"add": "Hinzufügen",
	"add-a-box": "Fügen Sie eine @.clientname:_box hinzu",
	"add-a-connector": "Fügen Sie einen Konnektor hinzu",
	"add-a-property": "Datenpunkt hinzufügen",
	"add-a-route": "Route hinzufügen",
	"add-a-trigger": "Fügen Sie einen Trigger hinzu",
	"add-alarm": "Alarm hinzufügen",
	"add-another-device": "Weiteres Gerät hinzufügen",
	"add-another-equipment": "Weiteres Gerät hinzufügen",
	"add-another-licence": "Weitere Lizenz hinzufügen",
	"add-archive-request": "Archiv anfordern",
	"add-bacnet-server-property": "Redirect a schedule stored in a controller",
	"add-boxes": "@.capitalize:boxes hinzufügen",
	"add-boxes-to-the-trigger": "Fügen Sie die @.lower:boxes zum Trigger hinzu",
	"add-config-link": "Einen Link hinzufügen, der zur Konfiguration weiterleitet",
	"add-custom-slug": "Add Custom Slug",
	"add-device": "Gerät hinzufügen",
	"add-equipment": "Gerät hinzufügen",
	"add-equipment-to-network": "Gerät dem Netzwerk hinzufügen",
	"add-equipment.advanced-description": "Geräte manuell hinzufügen",
	"add-equipment.bulk-creation": "Massenoperationen",
	"add-equipment.bulk-creation.knx": "Erstellung über die ETS-Software (KNX)",
	"add-equipment.bulk-creation.knx-description": "Exportieren Sie die Gruppenadressen aus der ETS-Software und importieren Sie die XML-Datei.",
	"add-equipment.bulk-creation.lorawan": "Massenhafte Erstellung von LoRaWAN-Geräten",
	"add-equipment.bulk-creation.lorawan-description": "Hinterlegen Sie eine CSV-Datei mit allen LoRaWAN-Geräten, die Sie hinzufügen möchten.",
	"add-equipment.preconfigured-description": "Die Datenpunkte des Geräts sind über ein Template auswählbar. Kompatibel mit den Protokollen: LoRaWAN, LPB (RVL), KNX (Synco) und  Modbus (RTU und TCP/IP).",
	"add-equipment.preconfigured-list": "Gerätebibliothek",
	"add-equipment.preconfigured-pick": "Wählen Sie ein Geräte-Template",
	"add-equipment.scan": "Scan",
	"add-equipment.scan.bacnet": "Scan eines BACnet-Netzwerks",
	"add-equipment.scan.bacnet-description": "Starten Sie einen Scan in einem BACnet-Netzwerk. Die Geräte und ihre Datenpunkte werden automatisch erkannt.",
	"add-equipment.scan.mbus": "Scan eines M-Bus-Netzwerks",
	"add-equipment.scan.mbus-description": "Starten Sie einen Scan in einem M-Bus-Netzwerk. Die Geräte und ihre Datenpunkte werden automatisch erkannt.",
	"add-event": "Event hinzufügen",
	"add-history-link": "Fügen Sie einen Link hinzu, der zu den neuesten Werten weiterleitet",
	"add-licence": "Lizenz hinzufügen",
	"add-network": "Netzwerk hinzufügen",
	"add-network-to-equipment": "Netzwerk zum Gerät hinzufügen",
	"add-new-box-privileges": "Neue @.lower:{'box'}-Rechte hinzufügen",
	"add-new-dashboard": "Dashboard",
	"add-new-slot": "Neuen Slot hinzufügen",
	"add-new-tag": "Neue Markierung hinzufügen",
	"add-property": "Datenpunkt hinzufügen",
	"add-property-from-list": "Add Property from the list",
	"add-property-to-graph": "Add property to graph",
	"add-recipient": "Weiterer Empfänger",
	"add-tag": "Markierung hinzufügen",
	"add-to-graph": "Add to graph",
	"add-user": "Add user",
	"add-user-to-organization": "Benutzer der Organisation hinzufügen",
	"add-widget": "Diagramm hinzufügen",
	"address": "Adresse",
	"address-mbus-range-1-to-250": "Adresse der M-Bus-Geräte in einem Bereich von 1 bis 250",
	"admin-account-details-for-new-organization": "Administrator-Account-Details für die neue Organisation",
	"advanced": "Erweitert",
	"advanced-mode": "Erweiterter Modus",
	"advanced-settings": "Erweiterte Einstellungen",
	"alarm": "Alarm",
	"alarm-SMS-notification-frequency-error-msg": "Muss mindestens 24 Stunden sein",
	"alarm-boolean-constraint-OFF-tooltip": "Der Alarm wird ausgelöst, wenn der Wert False ist.",
	"alarm-boolean-constraint-ON-tooltip": "Der Alarm wird ausgelöst, wenn der Wert True ist.",
	"alarm-box_connection_status-OFF": "@.capitalize:box nicht verbunden",
	"alarm-deleted": "Alarm gelöscht",
	"alarm-equipment-down-scenario": "Down",
	"alarm-equipment-status-notification-frequency-error-msg": "Muss mindestens 6 Stunden sein",
	"alarm-event-updated": "Alarm Event aktualisiert",
	"alarm-history-status-ACKNOWLEDGED": "Acknowledged",
	"alarm-history-status-CLOSED": "Geschlossen",
	"alarm-history-status-OPEN": "Offen",
	"alarm-map-banner-msg": "Ein oder mehrere Alarme sind ausgelöst worden. Gehe auf \"{clickhere}\", zur Identifizierung",
	"alarm-maximum-more-than-minimum": "Die obere Grenze dieses Bereichs sollte höher sein als die untere Grenze",
	"alarm-minimum-more-than-previous-maximum": "Die untere Grenze dieses Bereichs sollte höher sein als die obere Grenze des bisherigen Bereichs",
	"alarm-multirange-help-msg": "Wenn die obere Grenze des vorherigen Bereichs gleich der unteren Grenze des nächsten Bereichs ist, dann ist der nächste Bereich > (streng genommen mehr als) untere Grenze. <br />Andernfalls ist er >= (mehr als oder gleich) untere Grenze<br />Der Bereich ist immer <= (weniger als oder gleich) obere Grenze",
	"alarm-notification-frequency-help-msg": "Die erste Benachrichtigung wird versendet, sobald der Alarm ausgelöst wird. Eine Benachrichtigung kann dann höchstens alle {frequency} gesendet werden",
	"alarm-occurrence-time-interval": "Innerhalb",
	"alarm-occurrence-time-interval-tooltip": "Die Ereignisse müssen innerhalb dieses Intervalls auftreten. Bitte beachten Sie, dass das Standardintervall zwischen zwei Werten 10 Minuten beträgt.<br /> Der Zähler der Ereignisse wird zurückgesetzt, wenn die Bedingungen während des Zeitraums erfüllt wurden. Um erneut ausgelöst zu werden, müssen die Bedingungen während eines neuen Zeitraums eintreten.",
	"alarm-priority-updated": "Alarm Priorität aktualisiert",
	"alarm-property-measurement-boolean-constraint": "Der Wert liegt <b>True/False</b> oder <b>1/0</b>",
	"alarm-property-measurement-boolean-constraint-summary": "True / False",
	"alarm-property-measurement-notification-frequency-error-msg": "Muss mindestens 10 Minuten sein",
	"alarm-property-measurement-range-constraint-inrange": "Der Wert liegt <b>innerhalb des Bereichs</b>",
	"alarm-property-measurement-range-constraint-inrange-summary": "Innerhalb des Bereichs",
	"alarm-property-measurement-range-constraint-outrange": "Der Wert liegt <b>außerhalb des Bereichs</b>",
	"alarm-property-measurement-range-constraint-outrange-summary": "außerhalb des Bereichs",
	"alarm-property-measurement-set-constraint": "Der empfangene Wert gehört zu <b>einer Reihe von nicht zugelassenen Werten</b>",
	"alarm-property-measurement-set-constraint-summary": "Nicht zulässige Werte",
	"alarm-range-maximum-required": "Please provide a maximum value for the range",
	"alarm-range-minimum-required": "Please provide a minimum value for the range",
	"alarm-ranges": "Bereiche",
	"alarm-required-occurrences": "Anzahl der Ereignisse, die einen Alarm auslösen",
	"alarm-required-occurrences-tooltip": "Die Anzahl der Ereignisse, die erforderlich sind, damit der Alarm ausgelöst wird",
	"alarm-set-constraints-values": "Anzahl von Werten",
	"alarm-set-constraints-values-placeholder": "Wert hinzufügen",
	"alarm-sortby-name": "Name des Alarms (A-Z)",
	"alarm-sortby-triggered-at": "Datum der letzten Meldung (A-Z)",
	"alarm-type-box_connection_status": "@.capitalize:box Status Verbindung",
	"alarm-type-equipment-status-condition": "Bei einem Gerät, das eine Verbindung zur @.lower:box im <strong>LoRaWAN</strong> herstellt, gilt die Verbindung als unterbrochen, wenn in den letzten 12 Stunden keine Werte von dem Gerät empfangen wurden. <br />Bei einem Gerät, das über ein <strong>verdrahtetes Protokoll</strong> (BACnet, ModBus...) mit der @.lower:box verbunden ist, gilt die Verbindung als unterbrochen, wenn in der letzten Stunde für ein bestimmtes Gerät weniger Werte als erwartet empfangen wurden. Die Anzahl der erwarteten Werte wird automatisch berechnet.",
	"alarm-type-equipment_status": "Gerätestatus",
	"alarm-type-property_measurement": "Datenpunkt Messung",
	"alarm-valueset-duplicate-priorities": "Die Schweregrade von Mehrfachbeschränkungen müssen unterschiedlich sein.",
	"alarm-valueset-duplicate-values": "Einige Werte innerhalb der Sets sind doppelt vorhanden",
	"alarm-zone": "Alarmzone",
	"alarms": "Alarme",
	"alarms-route": "Alarmroute",
	"alarms-url": "Alarm-URL",
	"alert-raw-bytes-not-supported-bacnet-gateway": "Alle Datenpunkte, die das Datenformat {raw_bytes} haben, werden ausgeblendet, da sie noch nicht vom BACnet Gateway unterstützt werden.",
	"alerts-history": "Warnungen Historie",
	"all": "Alle",
	"all-configured": "Alles konfiguriert!",
	"all-equipment": "Alle Geräte",
	"all-properties": "Alle Datenpunkte",
	"an-optional-password-in-the-authentication": "Ein optionales Passwort für die Authentifizierung",
	"and": "und",
	"any": "Any",
	"api-device-id": "API Geräte Id",
	"api-documentation": "API Dokumentation",
	"api-keys": "API Schlüssel",
	"app-eui": "App EUI",
	"app-version": "APP Version",
	"apparently-havent-configured-box-go-to-configuration": "Offenbar haben Sie Ihre @.lower:box noch nicht konfiguriert. Gehen Sie zur Einrichtung in die Konfiguration!",
	"appeui": "AppEUI",
	"appkey": "AppKey",
	"application-extended-universal-identifier": "Erweiterte universelle Kennzeichnung der Anwendung",
	"application-extended-universal-identifier-provided-by-manufactor": "Kennzeichnung der Anwendung durch den Hersteller",
	"application-key": "Applikation Schlüssel",
	"apply": "Anwendung",
	"apply-changes": "Änderungen anwenden",
	"apply-severity-to-alarm": "Den neuen Schweregrad auf den Alarm anwenden",
	"apply-status-to-alarm": "Den neuen Status auf den Alarm übertragen",
	"applying-configuration-to-the-box": "Anwenden der Konfiguration auf den @.lower:box",
	"archive-applied-operation-on-data": "Applied operation on data",
	"archive-apply-operation-on-data": "Daten umwandeln",
	"archive-downloaded": "Archiv heruntergeladen",
	"archive-file-format": "Format der Archivdatei",
	"archive-no-transformation": "Keine Transformation",
	"archive-request": "Anfrage Datenarchiv",
	"archive-status-ENDED": "Abgeschlossen",
	"archive-status-FAILED": "Fehlgeschlagen",
	"archive-status-NEW": "Neu",
	"archive-status-STARTED": "Gestartet",
	"archive-transformation-diff-month": "Monatliche Differenz (letzter Wert des Monats - letzter Wert des Vormonats)",
	"archive-transformation-diff-week": "Wöchentliche Differenz (letzter Wert der Woche - letzter Wert der Vorwoche)",
	"archives": "Archiv",
	"are-you-creating-organization-internal-siemens-or-end-user": "Die Organisation ist für",
	"area": "Area",
	"array-length-error": "Array muss genau {length} Elemente enthalten",
	"as-soon-as-it-occurs": "Sobald dies geschieht",
	"at-least-one-property-is-redirect-confirm-rename": "At least one property of this equipment is redirected to a BACnet IP or a MQTT gateway. Such gateways can use the name of the equipment to name the properties. Do you want to reflect the new name of the equipment in the gateways?",
	"attention": "Warnung",
	"authentication": "Authentifizierung",
	"author": "Autor",
	"authorization-url": "Autorisierungs-URL",
	"autodiscovery.scan-didnt-find-results-after-x-minutes-review-config": "The scan has been running for {minutes} minutes and no device has been detected on {protocol} network. Would you like to review the configuration and run a new scan?",
	"autodiscovery.see-the-former-scan-and-let-running-in-background": "See former scan results & let the new scan run in the background",
	"autodiscovery.stop-scan-and-go-to-network-configuration": "Stop the scan & check the network configuration",
	"awaiting-next-reading": "Waiting for the next reading",
	"axis-left": "Links",
	"axis-right": "Rechts",
	"back": "Zurück",
	"bacnet-devices-not-complete": "Einige BACnet-Geräte sind noch nicht vollständig.",
	"bacnet-extra-days-help-msg": "32 für den letzten Tag des Monats <br />33 für die ungeraden Tage des Monats <br />34 für die geraden Tage des Monats",
	"bacnet-flag-FAULT": "Störung",
	"bacnet-flag-IN_ALARM": "In Alarm",
	"bacnet-flag-OK": "OK",
	"bacnet-flag-OUT_OF_SERVICE": "Out of service",
	"bacnet-flag-OVERRIDEN": "Overridden",
	"bacnet-ip-gateway-property": "BACnet Ip Gateway Datenpunkte",
	"bacnet-network-number": "The BACnet Netzwerknummer",
	"bacnet-object-name": "BACnet Object Name",
	"bacnet-property": "BACnet Datenpunkt",
	"bacnetscan.properties": "Datenpunkte:",
	"banner.autodiscovery-wait-for-scan": "Bitte warten Sie, während der Scan ausgeführt wird.",
	"banner.bulk-import.title": "Instructions for adding equipment in bulk",
	"banner.cache-refresher.body": "A new version is available and will be loaded when browsing a new screen.",
	"banner.cache-refresher.click-to-refresh": "Click here to load it immediately.",
	"banner.equipment-bulk-creation-advanced-config": "Equipment below require advanced configuration:",
	"banner.hub-live-data-activate.body": "Um die Werte der verschiedenen Geräte in der Konsole anzuzeigen, aktivieren Sie bitte den Schalter neben Ihrem @.capitalize:{'client-name-hub'}. Nach der Aktivierung und nach dem nächsten Auslesen steht der Wert für 60 Minuten zur Verfügung. Lokal werden die Werte immer empfangen und entsprechend weitergeleitet.",
	"banner.hub-live-data-activate.title": "Empfang von Datenpunktwerten aktivieren",
	"banner.satellite-licence": "Sie haben eine Satellite-Lizenz gewählt. Diese kann nur aktiviert werden, wenn sie zusammen mit einer anderen Box am selben Standort mit einer M- oder L-Lizenz verwendet wird.",
	"bars": "Bars",
	"base-url": "Basis-URL",
	"baudrate": "Baudrate",
	"bbmd-details": "BBMD Details",
	"bbmd-ip-address": "BBMD IP address",
	"bbmd-scenario-bbmd-config": "BACNet Broadcast Management Device",
	"bbmd-scenario-disabled": "Nicht aktiv",
	"bbmd-scenario-foreign-device": "Registrierung 3rd party Geräte",
	"bbmd-section-name": "BBMD, FD",
	"bbmd-table-box-ip-msg": "Die Zeile darunter ist mit der IP-Adresse des Geräts basierend auf der ausgewählten Schnittstelle vorausgefüllt. Diese Informationen sind erforderlich, damit das BBMD funktioniert",
	"bbmd-table-help-msg": "Damit der BBMD funktioniert, müssen Sie sicherstellen, dass die Tabelle in allen BBMD-Geräten gleich ist",
	"bbmd-table-no-box-ip-msg": "Die IP-Adresse Ihres Geräts kann anhand der ausgewählten Schnittstelle nicht erraten werden. Bitte manuell ausfüllen",
	"bbmd-time-to-live": "Time To Live",
	"bbmd-time-to-live-tooltip": "Länge der Zeit in Sekunden, bevor das Gerät eine Hallo-Nachricht an den BACnet-Host sendet",
	"below-line-graph-with-latests-values-from-property": "Nachfolgend ein Liniendiagramm mit den letzten erfassten Werten von {property}",
	"between-an-address-range": "Between an address range",
	"billing-contact": "Kaufmännischer Ansprechpartner",
	"bits-per-second": "bits per seconds",
	"block-type": "Diagramm Typ",
	"box": "@.clientname:_generic",
	"box-activated": "@.capitalize:box aktiviert",
	"box-connect": "@.capitalize:box verbunden",
	"box-didnt-receive-configuration": "@.capitalize:box hat die neue Konfiguration nicht erhalten.",
	"box-disconnect": "@.capitalize:box getrennt",
	"box-local-time": "@.capitalize:box locale Zeit",
	"box-name-in-network": "@.capitalize:box Name im Netzwerk",
	"box-or-hub": "@.capitalize:client-name-box oder @.capitalize:client-name-hub",
	"box-status.never-connected": "Nicht verbunden",
	"box-status.never-connected-to-the-platform": "Nie mit der Plattform verbunden",
	"box-status.offline": "Offline",
	"box-status.offline-connected-once": "Offline (mindestens einmal verbunden)",
	"box-status.online": "Online",
	"box-status.online-but-data-inactive": "@.capitalize:box connected to the console",
	"box-status.online-but-data-inactive-activate-communication": "Activate communication to receive property values",
	"box.views.logs.error_not_received-status": "Der Befehl wurde von @.lower:box auch nach mehreren Versuchen nicht empfangen",
	"box.views.logs.new-status": "Befehl ist gültig und wird auf der Cloud-Plattform gespeichert",
	"box.views.logs.received-status": "Der Befehl wurde von @.lower:box empfangen",
	"box.views.logs.retry_send-status": "Der Befehl wurde noch nicht von @.lower:box empfangen, es wird erneut versuchen",
	"box.views.logs.sent-status": "Der Befehl wurde an @.lower:box gesendet, es wurde noch keine Bestätigung von @.lower:box erhalten",
	"boxes": "@.clientname:_generic-plural",
	"broadcast": "Broadcast",
	"broadcast-distribution-table": "Broadcast Distribution Table",
	"broker": "Broker",
	"broker-port-number": "Broker port number",
	"broker-type": "Broker type",
	"broker-url": "Broker-URL",
	"bsp": "BSP",
	"bulk-creation": "Massenoperation",
	"bulk-import-file-error-msg": "Die abgelegte Datei hat nicht das richtige Format oder ihr Inhalt ist nicht zugänglich. Bitte überprüfen Sie das Dateiformat und versuchen Sie es erneut.",
	"bulk-import.advanced-configuration-codec-name": "Erweiterte Konfiguration {name}",
	"by-sending-config-from-da-config-will-overwrite-current-config-do-you-confirm": "Wenn die Konfiguration von der Desktop-Anwendung an den @.lower:hub gesendet wird, überschreibt die Konfiguration die aktuelle Daten. Die Änderungen werden nicht in der Konsole angezeigt. Sind Sie sich sicher?",
	"ca-certificate": "CA Certificate",
	"cancel": "Abbruch",
	"cancel-changes": "Änderungen verwerfen",
	"cant-activate-box-without-subscription-plan": "Sie können diese @.lower:box nicht aktivieren, weil sie nicht abonniert ist. Bitte kontaktieren Sie den Support.",
	"certificate": "Zertifikat",
	"certificate-authentication": "Tertifikatauthentifizierung",
	"certificate-authentication-required": "Zertifikatsauthentifizierung ist erforderlich",
	"certificate-deleted": "Zertifikat gelöscht",
	"certificate-store-id": "Zertifikat Speicher",
	"certificate-updated": "Zertifikat aktualisiert",
	"certificates": "Zertifikate",
	"change": "Änderung",
	"change-alarm-settings": "Alarm Einstellungen ändern",
	"change-alert-status": "Status der Warnung ändern",
	"change-box-hub-name": "@.capitalize:{'box'}-Name ändern",
	"change-data-format-to-f32": "Bitte ändern Sie das Datenformat und verwenden Sie stattdessen ein f32-Datenformat (f32_dcba statt float_abcd, f32_cdab statt float_badc, f32_abcd statt float_dcba und f32_badc statt float_cdab)",
	"change-severity-of-alert": "Ändern Sie den Schweregrad der Warnung",
	"change-value-fields-restrict-scan-equipment-identification-number-matching-pattern": "Ändern Sie den Wert der Felder, um den Scan auf die Geräteidentifikationsnummer zu beschränken, die dem Muster entspricht.",
	"chat": "Chat",
	"check-hub-configuration": "@.capitalize:{'hub'}-Konfiguration prüfen",
	"check-request-scan": "Prüfen, ob @.lower:box die Anfrage zur Durchführung des Scans erhalten hat",
	"choose-a-file": "Datei auswählen",
	"choose-dates": "Daten auswählen",
	"choose-equipment-or-run-scan-bacnet": "Gerät auswählen oder Scan im Falle eines BACnet Netzwerkes durchführen",
	"class-type": "Class type",
	"clear": "Löschen",
	"clear-selection": "Auswahl aufheben",
	"click-here": "Hier klicken",
	"click-here-touse-equipment-default-configuration": "Hier klicken, um die Standardkonfiguration zu verwenden",
	"click-to-add-change-scaling": "Klicken Sie hier, um die Skalierung hinzuzufügen/zu ändern",
	"click-to-add-change-unit": "Klicken Sie hier, um die Einheit hinzuzufügen/zu ändern",
	"click-to-copy": "Zum Kopieren klicken",
	"click-to-copy-table-to-clipboard": "Hier klicken, um die Tabelle in die Zwischenablage zu kopieren",
	"clicking-here": "Hier klicken",
	"client-authentication-method": "Client-Authentifizierungsmethode",
	"client-authentification": "Client-Authentifizierung",
	"client-authentification-method": "Client-Authentifizierungsmethode",
	"client-certificate": "Client Certificate",
	"client-id": "Client ID",
	"client-name-box": "@.clientname:_box",
	"client-name-boxes": "@.clientname:_boxes",
	"client-name-generic": "@.clientname:_generic",
	"client-name-generic-plural": "@.clientname:_generic-plural",
	"client-name-hub": "@.clientname:_hub",
	"client-name-hubs": "@.clientname:_hubs",
	"client-secret": "Client-secret",
	"close": "Schließen",
	"close-alert": "Warnung schließen",
	"close-or-acknowledge-previous-alerts-from-this-alarm": "Schließen oder quittieren Sie die mit diesem Alarm verknüpften vorherigen Alarme.",
	"closed": "Geschlossen",
	"code": "Code",
	"codec-id": "Codec ID",
	"collapse-button-equipment-tooltip": "Alle Geräte zuklappen",
	"collapse-button-groups-tooltip": "Alle Gruppen zuklappen",
	"combination-of-baseurl-and-this-route-is-not-valid": "The combination of Base URL and this route is not valid: {url}",
	"combination-of-brokerurl-and-this-route-is-not-valid": "The combination of Broker URL and this route is not valid: {url}",
	"comfort-reached-at": "Komfort wird erreicht bei",
	"command": "Befehl",
	"command-of-configuration": "Befehl der Konfiguration",
	"command-scan-not-received-by-box": "Der Scan-Befehl wurde vom @.lower:box nicht empfangen.",
	"command-status-ERROR_NOT_RECEIVED": "ERROR_NOT_RECEIVED",
	"command-status-NEW": "NEW",
	"command-status-RECEIVED": "RECEIVED",
	"command-status-RETRY_SEND": "RETRY_SEND",
	"command-status-SENT": "SENT",
	"command-status-tooltip": "New<br />Befehl ist gültig und wartet darauf, an das Gerät gesendet zu werden.<br /><br />Error_not_received<br />Der Befehl wurde vom Gerät auch nach mehreren Versuchen nicht empfangen.<br /><br />Sent<br />Der Befehl wurde an das Gerät gesendet. Warten auf die Empfangsbestätigung des Geräts. <br /><br />Received<br />Der Befehl wurde vom Gerät empfangen.<br /><br />Retry_send<br />Der Befehl wurde vom Gerät nicht empfangen. Es wird ein neuer Versuch unternommen.",
	"command-to-send-to-device-to-read-write": "Command to send to the device to read/write",
	"command-type-DISCOVER": "DISCOVER",
	"command-type-READ_REQUEST": "READ_REQUEST",
	"command-type-RESTART": "RESTART",
	"command-type-SEND_CONFIG": "SEND_CONFIG",
	"command-type-SET_PROPERTY": "SET_DATAPOINT",
	"command-type-WS_CONFIG": "WS_CONFIG",
	"comment": "Bemerkung",
	"communication-mode": "Kommunikationsmodus",
	"communication-mode-to-use": "Der zu verwendende Kommunikationsmodus",
	"components.buttons-expand-collapse.collapse": "Collapse all",
	"components.buttons-expand-collapse.expand": "Expand all",
	"components.demo-account.account": "Demo Account",
	"components.layouts.app.components.global-search.boxes-result.no-result": "0 @.lower:boxes found with the search criteria",
	"components.layouts.app.components.global-search.equipment-result.no-result": "0 equipment found with the search criteria",
	"components.layouts.app.components.global-search.modal-globlal-search.failed-getting-boxes": "Failed getting list of @.lower:boxes",
	"components.layouts.app.search.search-for-box": "Suche nach @.lower:box",
	"components.paginator.next": "Nächste Seite",
	"components.paginator.previous": "Vorherige Seite",
	"condition": "Voraussetzung",
	"configuration": "Konfiguration",
	"configuration-changed-but-not-applied-send-to-box": "Die Konfiguration wurde bearbeitet, aber die Änderungen wurden nicht mit dem @.lower:box synchronisiert. Senden Sie die Konfiguration an den @.lower:{'box'}, um sie zu übernehmen.",
	"configuration-get-network-id-to-scan-msg": "Netzwerk für die Durchführung des Scans aktivieren",
	"configuration-imported": "Konfiguration importiert",
	"configuration-imported-with-success": "Import der Konfiguration war erfolgreich",
	"configuration-in-the-box": "Konfiguration in der @.lower:box",
	"configuration-recreating-draft-msg": "Recreating draft configuration",
	"configuration-saving-msg": "Konfiguration in der @.lower:box speichern",
	"configuration-verify-exist-scan-msg": "Verifying if a Scan exists",
	"configuration-waiting-to-apply": "Waiting for @.lower:box to apply configuration",
	"configuration-was-successfully-applied-to-hub": "The configuration was successfully applied to your @.lower:{'hub'}!",
	"configuration-wizard": "Konfigurations-Assistent",
	"configure-connector": "Anschluss konfigurieren",
	"configure-ethernet-connector": "Ethernet Anschluss konfigurieren",
	"configure-gateway": "Gateway konfigurieren",
	"configure-heating-optimiser": "Configure Heating Optimiser",
	"configure-how-to-run-the-mbus-scan": "Configure how to run the MBUS scan",
	"configure-individual-and-internal-address-box": "Configure Individual and Internal Address of the @.lower:{'box'}.",
	"configure-knx-network": "KNX Netzwerk konfigurieren",
	"configure-lon-ip852-network": "LON IP852 Netzwerk konfigurieren",
	"configure-lorawan-network": "LoRaWAN Netzwerk konfigurieren",
	"configure-mbus-protocol": "MBUS Protokoll konfigurieren",
	"configure-network-RVL-equipment": "Netzwerk für RVL Geräte konfigurieren",
	"configure-network-lon-ip852": "LON IP852 Addresse in @.lower:box konfigurieren",
	"configure-new-gateway": "Neues Gateway konfigurieren",
	"configure-new-routing": "Neue Route hinzufügen",
	"configure-properly-property": "Configure properly the DATAPOINT",
	"configure-routing": "Route konfigurieren",
	"configuring-bacnet-msg": "Configuring @.lower:{'box'}. This might take a while. Hold on, please.",
	"configuring-connector": "Anschluss konfigurieren",
	"configuring-network": "Netzwerk konfigurieren",
	"confirm": "Confirm",
	"congratulations": "Herzlichen Glückwunsch!",
	"connection": "Verbindungs",
	"connection-inactive": "Verbindung inaktiv",
	"connection-ko": "Connection KO",
	"connection-ok": "Verbindung in Ordnung",
	"connectivity": "Verbindung",
	"connector": "Anschluss",
	"connector-and-triggers-duplicated": "Anschluss und Trigger dupliziert",
	"connector-canot-get-ip-address": "Connector {connector} can't get an IP Address",
	"connector-configuration-different-from-equipment-default-configuration": "The connector configuration is different from equipment default configuration (ignore this warning if you have changed the configuration from the equipment).",
	"connector-ko-because-cant-get-ip": "The connector is KO because it can't get an IP address",
	"connector-name-triggers": "Anschluss „{name}“ löst aus",
	"connector-saved": "Anschluss gespeichert",
	"connectors": "Anschlüsse",
	"connectors-for": "Anschlüsse für \"{name}\"",
	"copied-to-clipboard": "In die Zwischenablage kopiert",
	"copy": "Kopieren",
	"copy-all-info": "Kopieren Sie alle Informationen",
	"copy-of": "Kopie von",
	"copy-to-clipboard": "In die Zwischenablage kopieren",
	"count": "Anzahl",
	"create-a-lorawan-network": "LoRaWAN Netzwerk erstellen",
	"create-a-new-network": "Neues Netzwerk erstellen",
	"create-archive-request": "Datenarchiv erstellen",
	"create-equipment": "Gerät erstellen",
	"create-equipments": "Gerät erstellen",
	"create-licence-for-this-organization": "Erstellen Sie eine Lizenz für diese Organisation",
	"create-lorawan-network": "LoRaWAN Netzwerk erstellen",
	"create-new-equipment": "Neues Gerät erstellen",
	"create-new-gateway": "Neues Gateway erstellen",
	"create-new-notification": "Create new notification",
	"create-new-organization": "Organisation erstellen",
	"create-new-properties": "Neue Datenpunkte erstellen",
	"create-properties": "Datenpunkte erstellen",
	"create-the-trigger": "Erstellen Sie den Trigger",
	"create-your-first-connector": "Erstellen Sie Ihren ersten Anschluss",
	"create-your-first-trigger": "Erstellen Sie Ihren ersten Trigger",
	"created-at": "Created at",
	"created-by": "Created by",
	"creating-all-equipment": "Alle Geräte erstellen",
	"creation-date": "Erstellungsdatum",
	"critical": "Kritisch",
	"csv-file-format": "The file should be in the CSV format with comma (,) delimiter",
	"current": "Current",
	"current-configuration": "Current configuration",
	"current-value": "Aktueller Wert",
	"curve": "Curve",
	"custom": "benutzerdefiniert",
	"custom-mqtt-slug": "Custom MQTT slug",
	"custom-routing-table": "Benutzerdefinierte Routing-Tabelle",
	"daily": "Täglich",
	"daily-schedule-help-msg-1": "Da das Equipment vom Typ RVL ist, kann man bis zu 6 Slots pro Tag definieren. Der NORMAL-Modus wird zu Beginn des Slots angewendet. Sie endet je nach Ihren Einstellungen entweder zu Beginn des nächsten Slots oder am Ende des Tages. Zwischen und außerhalb der Slots gilt der REDUZIERTE Modus.",
	"daily-schedule-help-msg-1-knx": "Bitte achten Sie auf die Ortszeit der Ausrüstung, da der Zeitplan in der Ausrüstung gespeichert und von der Ausrüstung ausgeführt wird.",
	"daily-schedule-help-msg-2-knx": "Da das Gerät vom Typ Synco ist, können Sie bis zu 6 Slots definieren. Der DEFAULT-Modus gilt bis zum Beginn des ersten Slots.",
	"daily-schedule-invalid-consecutive-time": "Startzeit stimmt nicht mit der Startzeit des vorherigen Slots überein",
	"daily-schedule.copy-day-btn": "Wenden Sie diesen Zeitplan an auf ",
	"dashboard": "Dashboard",
	"dashboard-name": "Dashboard Name",
	"dashboard-properties-table-tooltip": "Select the Datpoints you would like to see in the cells of the table",
	"dashboard-properties-tile-tooltip": "There will be as many \"Single value\"charts added to the Dashboard as there are Datapoints selected",
	"dashboards": "Dashboards",
	"data-bits": "Data bits",
	"data-format": "Daten Format",
	"data-point-type": "Datenpunkt Typ",
	"data-points-expected-got": "Values received/expected in the last hour: {got}/{expected}",
	"data-streams": "Data Streams",
	"data-streams-available-only-boxes-because-data-have-be-present-in-console": "Data streams are only available for @.clientname:_boxes because the data have to be present in the console",
	"data-type": "Daten Typ",
	"datastream-connector-error.cause-label": "Cause:",
	"datastream-connector-error.error-label": "Error:",
	"datastream-connector-error.mqtt-custom.authentication": "CUSTOM broker type must have at least one type of authentication: either basic authentication or certificate authentication",
	"date": "Datum",
	"date-range": "Datumsbereich",
	"date-time-is-out-of-service-msg": "Diese Ausnahme ist deaktiviert. Bearbeiten Sie den Datenpunkt, um sie zu aktivieren.",
	"datepicker-last-x-days": "Letzte {days} Tage",
	"datepicker-last-year": "Letzes Jahr",
	"dates-and-time": "Datum & Zeit",
	"day": "Tag",
	"days": "Tage",
	"default": "Standard",
	"default-class-a": "Standard (class A)",
	"default-format-used-for-slug-properties": "Default format used for the the datapoints slug. The value can be personalized for each datapoint.",
	"default-routing-table": "Standard-Routing-Tabelle",
	"default-severity": "Standard Schweregrad",
	"default-value": "Standard Wert",
	"defines-end-of-event": "Defines the time event ends.",
	"defines-how-data-is-interpreted-and-encoded-equipment": "Definiert, wie die Daten auf dem Gerät interpretiert und codiert werden sollen",
	"defines-start-of-event": "Defines the start of the event and when it will happen.",
	"delete": "Löschen",
	"delete-certificate": "Zertifikat löschen",
	"delete-connector": "Anschluss löschen",
	"delete-properties": "Datenpunkt löschen",
	"delete-trigger-triggername": "Trigger \"{trigger}\" löschen?",
	"delete-x-properties": "Delete 1 property | Delete {x} properties",
	"description": "Beschreibung",
	"description-use-mask-identification-number": "Es werden nur die Geräte abgerufen, deren Identifikationsnummer in ihrer Sekundäradresse mit der Maske übereinstimmt.",
	"destination": "Ziel",
	"details": "Details",
	"dev-eui": "Dev EUI",
	"deveui": "DevEUI",
	"device": "Gerät",
	"device-created-with-success": "Gerät erfolgreich erstellt",
	"device-extended-universal-identifier": "Device Extended Universal Identifier",
	"device-instance": "Device Instance",
	"device-instance-for-network-this-device-instance-unique-on-box": "Eine Geräteinstanz für das Netzwerk der @.lower:{'box'}. Diese Geräteinstanz muss auf der @.lower:box eindeutig sein.",
	"device-name": "Geräte Name",
	"device-number": "Geräte Nummer",
	"device-number-description": "Die Gerätenummer des LPB-Geräts",
	"device-type": "Gerätetyp",
	"devices": "Gerät",
	"devices-found": "Geräte gefunden",
	"dialog-active-box.box-name-tooltip": "Geben Sie einen Namen für die {box} (Sie können diesen später noch ändern)",
	"dialog.archive-sent.body": "Der Export Ihres Archivs ist in Arbeit. Die Daten werden nach Abschluss per E-Mail versendet.",
	"dialog.archive-sent.title": "Anfrage gesendet",
	"dialog.autodiscovery-refresh-scan.body": "Alle ausgewählten Datenpunkte werden deselektiert, wenn Sie den Scan aktualisieren.",
	"dialog.autodiscovery-refresh-scan.title": "Scan aktualisieren",
	"dialog.config-wizard-request-equipment.body": "Wir bearbeiten Ihre Anfrage. Unser Team wird Sie per E-Mail kontaktieren, um Sie über den Fortschritt zu informieren.",
	"dialog.config-wizard-request-equipment.title": "Anfrage gesendet",
	"dialog.datastream-connector-error.confirm": "Anschluss bearbeiten",
	"dialog.datastream-connector-error.title": "Data Stream error",
	"dialog.delete-alarm.body": "Dadurch werden der Alarm \"{name}\" und alle mit dem Alarm verknüpften Benachrichtigungen gelöscht.",
	"dialog.delete-alarm.title": "Alarm löschen",
	"dialog.delete-api-key.body": "Dadurch wird der API-Schlüssel \"{name}\" gelöscht. Es kann nicht rückgängig gemacht werden.",
	"dialog.delete-api-key.title": "API Schlüssel löschen",
	"dialog.delete-config.body": "Dadurch werden alle Änderungen gelöscht, die seit dem letzten Speichern an der Konfiguration vorgenommen wurden.",
	"dialog.delete-config.confirm": "Änderungen zurücksetzen",
	"dialog.delete-config.title": "Änderungen zurücksetzen",
	"dialog.delete-dashboard-block.title": "Diagramm löschen",
	"dialog.delete-dashboard.title": "Dashboard löschen",
	"dialog.delete-equipment.body": "Dadurch wird das Gerät \"{equipment}\" und alle seine Datenpunkte ({properties}) gelöscht.",
	"dialog.delete-equipment.checkbox": "Löschen Sie die Gateway-Datenpunkte, die mit diesem Gerät verknüpft sind. Wenn nicht aktiviert, werden die umgeleiteten Eigenschaften beibehalten.",
	"dialog.delete-equipment.title": "Gerät löschen",
	"dialog.delete-event.title": "Ereignis löschen",
	"dialog.delete-gateway.body": "Dies löscht \"{gateway}\" und alle seine Datenpunkte ({properties}).",
	"dialog.delete-gateway.title": "Gateway löschen",
	"dialog.delete-graph.body": "Wird diese Grafik gelöscht",
	"dialog.delete-graph.title": "Grafik löschen",
	"dialog.delete-network.body": "Dadurch wird das Netzwerk \"{network}\" gelöscht. Es werden nicht die bereits in diesem Netzwerk konfigurierten Geräte oder Gateways gelöscht.",
	"dialog.delete-network.title": "Netzwerk löschen",
	"dialog.delete-notifications.title": "Delete event notification",
	"dialog.delete-property.body": "Dadurch wird der Datenpunkt \"{property}\" gelöscht. Alle früheren Werte des Datenpunkt werden gelöscht. Die Weiterleitungen von oder zu diesem Datenpunkt werden gelöscht.",
	"dialog.delete-property.title": "Eigenschaft löschen",
	"dialog.delete-routing.body": "Dadurch wird das Routing \"{name}\" gelöscht.",
	"dialog.delete-routing.title": "Routing löschen",
	"dialog.graph-archive-sent.body": "Ihre Anfrage wird bearbeitet. Sie erhalten eine Benachrichtigung per E-Mail, sobald die Anfrage abgeschlossen ist.",
	"dialog.graph-archive-sent.title": "Anfrage gesendet",
	"dialog.graph-unsaved-changes-delete.body": "Soll diese Grafik gelöscht werden?",
	"dialog.graph-unsaved-changes-save.body": "Sie haben nicht gespeicherte Änderungen. Wenn Sie diese Seite verlassen, werden die an der Grafik vorgenommenen Änderungen gelöscht",
	"dialog.graph-unsaved-changes.title": "Seite mit ungespeicherten Änderungen verlassen?",
	"dialog.lorawan-equipment-duplication.body": "Bitte führen Sie eine erneute Verbindung zwischen dem Gerät und dem \"{boxDestinationName}\" durch.",
	"dialog.lorawan-equipment-duplication.cancel": "Schließen",
	"dialog.lorawan-equipment-duplication.confirm": "Zum duplizierten Gerät wechseln",
	"dialog.lorawan-equipment-duplication.title": "Gerät dupliziert. Was möchten Sie jetzt tun?",
	"dialog.lpb-equipment-device-number-1.body": "Sie haben die Gerätenummer auf 1 gesetzt, was bedeutet, dass das Gerät {equipmentName} der Master auf dem Segment {segmentNumber} sein wird. Ist das richtig?",
	"dialog.lpb-equipment-device-number-1.title": "LPB Gerät",
	"dialog.lpb-equipment-segment-number.body": "Sie setzen die Segmentnummer auf {segmentNumber}. Das auf der @.lower:box registrierte LPB-Netzwerk verwendet die Segmentnummer {boxSegmentNumber}. Unterschiedliche Segmentnummern bedeuten, dass die @.lower:box nicht mit dem neuen Gerät kommunizieren kann. Sind Sie sicher?",
	"dialog.lpb-equipment-segment-number.title": "LPB Gerät",
	"dialog.mqtt-slug-change.body": "Wenn Sie das Format des Slugs ändern, werden alle im Gateway definierten Eigenschaften, die keinen benutzerdefinierten Slug haben, das neue Format annehmen. Bestätigen Sie die Änderungen?",
	"dialog.mqtt-slug-change.title": "Slug modifizieren?",
	"dialog.request-new-scan.body": "Diese Aktion löscht den aktuellen Scan. Er kann nicht rückgängig gemacht werden. Je nach Netzwerk kann der neue Scan einige Zeit dauern.",
	"dialog.request-new-scan.title": "Neuen Scan anfordern",
	"dialog.rvl-even-slots.body": "Die Anzahl der editierten Slots ist ungerade. Um dem Verhalten des RVL gerecht zu werden, wird ein letzter Slot mit dem Modus (\"REDUCED\") hinzugefügt. Wenn Sie nicht einverstanden sind, fügen Sie bitte einen anderen Slot hinzu.",
	"dialog.rvl-even-slots.confirm": "Slot hinzufügen",
	"dialog.rvl-even-slots.title": "Slot automatisch hinzufügen?",
	"dialog.virtual-properties.delete-property-body": "Dadurch wird der virtuelle Datenpunkt \"{Name}\" gelöscht. Alle früheren Werte des Datenpunktes werden gelöscht.",
	"dialog.virtual-properties.delete-property-title": "Virtuellen Datenpunkt löschen",
	"dialog.wizard-gateway-exit.body": "Wenn Sie diese Seite verlassen, werden Änderungen gelöscht, die an der Auswahl vorgenommen wurden.",
	"dialog.wizard-gateway-exit.title": "Seite verlassen?",
	"different-lpb-related-data-formats": "Verschiedene LPB-bezogenen Datenformate, die von der neuesten Version des Geräts unterstützt werden",
	"disable": "Deaktivieren",
	"disable-x-properties": "1 Datenpunkt deaktivieren | {x} Datenpunkte deaktivieren",
	"disabled-lorawan-tti-tooltip": "Sie können diese Datenpunkte nicht umleiten, da sich Ihr LoRaWAN-Server nicht in der @.lower:box befindet",
	"discontinued-in": "eingestellt am {date}",
	"do-not-update-equipment": "Only the equipment",
	"do-not-update-property": "Only the property",
	"do-you-want-to-delete-connector": "Möchten Sie diesen Anschluss löschen {connector}?",
	"documentation": "Dokumentation",
	"does-it-end": "Endet dies?",
	"doesnt-work-lorawan-because-lorawan-sensors-autonomous-decides-its-own-when-sends-data": "Dies kann nicht mit LoRaWAN-Sensoren verwendet werden, da es autonom arbeitet und selbst entscheidet, wann Daten gesendet werden.",
	"domain": "Domain",
	"domain-box-on-lon-ip-network": "The domain of the @.lower:box on the LON IP network",
	"dont-have-permission-to": "Sie haben keine Berechtigung für {action}",
	"dot-not-update-no-confidence": "Wenn Sie sich unsicher sind, empfehlen wir, die Änderungen nicht auf die Gateways anzuwenden.",
	"down": "KO",
	"downlink-topic": "Downlink topic",
	"download": "Download",
	"download-configuration": "Download Konfiguration",
	"download-desktop-app": "Download Desktop App",
	"download-license": "Download Lizenz",
	"download-link": "Download Link",
	"download-the-error-report": "Download Fehler Report",
	"download-this-template": "Template herunterladen",
	"downloading-archive": "Download Archiv",
	"draft": "Draft",
	"draft-configuration": "Draft Konfiguration",
	"drag-drop-file-or-click": "Ziehen Sie Ihre Datei per Drag & Drop oder klicken Sie auf die Schaltfläche",
	"drag-drop-file-or-click-button": "Ziehen Sie Ihre Datei per Drag & Drop oder klicken Sie auf die Schaltfläche",
	"drag-file-here": "Datei hierhin ziehen",
	"drag-image-here": "Drag and drop or choose a file to upload your image. All .png, .jpeg and .jpg file types are supported.",
	"duplicate": "Kopieren",
	"duplicate-connector": "Doppelter Anschluss",
	"duplicate-equipment": "Gerät kopieren",
	"duplicate-lorawan-equipment": "LoRaWAN Gerät kopieren",
	"duplicate-trigger": "Doppelter Trigger",
	"edit": "Bearbeiten",
	"edit-configuration": "Edit the configuration",
	"edit-connector": "Anschluss bearbeiten",
	"edit-equipment-new-tab": "Open equipment properties in a new tab",
	"edit-event": "Event bearbeiten",
	"edit-indicator": "Edit Indicator",
	"edit-properties": "Datenpunkte bearbeiten",
	"edit-property": "Datenpunk bearbeiten",
	"edit-trigger": "Trigger bearbeiten",
	"effective-period": "Gültiger Zeitraum",
	"effective-period-invalid-range": "Die Start- und Endtage müssen zusammenhängend sein",
	"email": "E-Mail",
	"email-to": "E-Mail an",
	"enable": "Aktivieren",
	"enable-edition-of-network-configuration": "Freigabe der Netzwerkkonfiguration",
	"enable-plural": "aktiviert",
	"enable-temporization-msg": "Alarm automatisch schließen, wenn der Zustand wieder normal wird",
	"enable-temporization-tooltip": "Wenn die Bedingung mit einer Anzahl von Ereignissen nicht mehr beobachtet wird, die der zum Auslösen des Alarms erforderlichen Anzahl entspricht, und während desselben Intervalls, wird der Alarm geschlossen und seine Historie.",
	"enable-x-properties": "1 Datenpunkt deaktivieren | {x} Datenpunkte deaktivieren",
	"encryption": "Verschlüsselung",
	"end": "Ende",
	"end-date": "Enddatum",
	"end-time": "Endzeit",
	"ending": "Ende",
	"enter-brand-model-or-select-from-list": "Enter Brand or Model or select in the list",
	"enter-code-list-codes-or-enter-asterisks-to-any-code": "Enter a code {url}. Or enter '*' to be notified for any code.",
	"equipment": "Gerät",
	"equipment-bulk-create-import-csv-msg1": "Adding devices in bulk is only available for devices that use <strong>LoRaWAN</strong> and that are included in our <strong>decoded equipment library</strong>.",
	"equipment-bulk-create-import-csv-msg2": "The list of equipment must respect a precise format. {template} and complete it with the desired equipment.",
	"equipment-bulk-create-network-existing-msg": "A LoRaWAN network already exists. If you change its configuration, it will change the equipment attached to it too. If you want to change the network configuration, click in the button below.",
	"equipment-bulk-create-network-msg": "You haven't created a LoRaWAN network yet. Please create one before proceeding to create the equipment. The new equipment will use this network",
	"equipment-creation": "Creation of equipment",
	"equipment-creation-mapping-msg": "Please associate each model from your file with the corresponding reference",
	"equipment-deleted": "Equipment deleted",
	"equipment-discriminator": "Equipment Discriminator",
	"equipment-discriminator-description": "Information identifying the equipment: DevEUI for LoRaWAN, Device Instance for BACnet, etc",
	"equipment-duplicated-successfully": "Equipment duplicated successfully",
	"equipment-id": "Geräte ID",
	"equipment-name": "Geräte Name",
	"equipment-plural": "Gerät | Gerät",
	"equipment-properties": "Geräte Datenpunkte",
	"equipment-required": "Equipment is required",
	"equipment-status-indicator-info-tooltip-txt": "KO: no data received in the last hour (24 hours for LoRaWAN equipment)<br />- : no connection status available for this equipment",
	"equipment-with-mbus-protocol": "Equipment with MBUS protocol",
	"equipment-with-modbus-serial-protocol": "Equipment with Modbus RTU protocol",
	"equipment-with-percentage-scan-refresh-to-update": "Equipment with {percentage}% scan concluded. Refresh scan to update.",
	"equipments": "Gerät",
	"equipments-status-to-be-checked-and-alarm-raised": "Keine Verbindugn mit dem Gerät",
	"equipments.bms": "BMS",
	"equipments.meters": "Zähler",
	"equipments.others": "Andere",
	"error-communicating-with-hub-reception-properties-values-not-available": "Error while communicating with the @.lower:{'hub'}. The reception of the datapoints values is not available.",
	"error-field-hexadecimal-length": "{field} should be {characters} UPPERCASE hexadecimal characters",
	"error.min-1-character": "Das Feld sollte mindestens 1 Zeichen enthalten.",
	"errors": "Errors",
	"even-months": "Gerade Monate",
	"event": "Event",
	"event-code-0-999": "Generic",
	"event-code-0-999-range": "Generic (0 to 999)",
	"event-code-1000-1999": "Konfiguration",
	"event-code-1000-1999-range": "Konfiguration (1000 to 1999)",
	"event-code-2000-2999": "Netzwerk",
	"event-code-2000-2999-range": "Netzwerk (2000 to 2999)",
	"event-code-3000-3999": "Gerät",
	"event-code-3000-3999-range": "Gerät (3000 to 3999)",
	"event-code-4000-4999": "Datenpunkte",
	"event-code-4000-4999-range": "Datenpunkte (4000 to 4999)",
	"event-code-5000-5999": "Gerät",
	"event-code-5000-5999-range": "Gerät (5000 to 5999)",
	"events-route": "Event Route",
	"events-url": "Event-URL",
	"every-time-alarm-history-item-is-created": "Jedes Mal, wenn ein Element in der Alarmhistorie erstellt wird",
	"every-time-event-matching-code-received-on-console": "Jedes Mal, wenn ein dem Code entsprechendes Ereignis auf der Konsole empfangen wird",
	"every-time-value-property-received-on-console": "Jedes Mal, wenn der Wert eines Datenpunktes auf der Konsole empfangen wird",
	"exception": "Ausnahme",
	"existant-graph": "Existing graph",
	"expand-button-equipment-tooltip": "Alle Geräte aufklappen",
	"expand-button-groups-tooltip": "Alle Geräte aufklappen",
	"expand-collapse": "Expand/Collapse",
	"expected-value": "Erwarteter Wert",
	"expiration-date": "Ablaufdatum",
	"expired": "Abgelaufen",
	"export": "Export",
	"export-configuration": "Export Konfiguration",
	"extended-time-max-format": "\"24:00\" ist der letzte autorisierte Wert",
	"extended-time-seconds-max-format": "\"24:00:00\" ist der letzte autorisierte Wert",
	"external": "Extern",
	"external-id": "Externe ID",
	"external-recipient": "Der Empfänger hat oder wird keinen Zugriff auf die Konsole haben",
	"fail-copying-to-clipboard": "Kopieren in die Zwischenablage fehlgeschlagen",
	"failed": "Fehlgeschlagen",
	"failed-activating-box": "Aktivierung @.lower:box fehlgeschlagen",
	"failed-adding-privileges-to-user": "Failed adding privileges to user",
	"failed-adding-property": "Failed adding datapoint: {property}",
	"failed-bacnet-scan-autodiscovery": "Failed getting BACnet Scan. Please check your configuration.",
	"failed-creating-draft-refresh-page": "Failed creating Draft. Refresh the page, please.",
	"failed-creating-equipment": "Error when creating the equipment. Download the source file with the error messages. Then use it in step 1 to keep the correspondance of each equipment with its reference.",
	"failed-creating-gateway-properties": "Erstellen von Gateway Datenpunkten fehlgeschlagen",
	"failed-creating-new": "Fehler beim Erstellen eines neuen {thing}",
	"failed-creating-organization": "Erstellen einer neuen Organisation fehlgeschlagen",
	"failed-creating-params-to-save-network": "Parameter zum Speichern des Netzwerks konnten nicht erstellt werden",
	"failed-creating-properties": "Error when creating the equipment. Download the source file with the error messages.",
	"failed-deleting-certificate": "Fehler beim Löschen des Zertifikats",
	"failed-deleting-connector": "Anschluss löschen fehlgeschlagen",
	"failed-deleting-equipment": "Gerät löschen fehlgeschlagen",
	"failed-deleting-rate-plan": "Fehler beim Löschen des Rate plans",
	"failed-downloading-archive-request-it-again": "Failed downloading archive, please request a new one.",
	"failed-downloading-desktop-app": "Download Desktop App fehlgeschlagen",
	"failed-downloading-equipment-list": "Fehler beim Herunterladen der Geräteliste",
	"failed-downloading-license": "Dwonload Lizenz fehlgeschlagen",
	"failed-duplicating-equipment": "Gerät kopieren fehgeschlagen",
	"failed-duplicating-trigger": "Fehler beim Duplizieren des Triggers {name}",
	"failed-exporting-hub-configuration": "Export @.lower:hub Konfiguration fehlgeschlagen",
	"failed-get-draft-config": "Failed getting draft configuration",
	"failed-get-graph": "Failed getting graphs",
	"failed-get-networks-from-connectors": "Netzwerkaufbau von den Anschlüssen fehlgeschlagen",
	"failed-getting-alarms": "Abfrage Alarme fehlgeschlagen",
	"failed-getting-alarms-history": "Abfrage der Alarm Historie fehlgeschlagen",
	"failed-getting-archives": "Failed getting data archives",
	"failed-getting-available-bacnet-data-types": "Failed getting available BACnet Data Types",
	"failed-getting-available-networks": "Failed getting available networks",
	"failed-getting-connectors-configuration": "Failed getting connectors configuration",
	"failed-getting-current-configuration": "Failed getting current configuration",
	"failed-getting-encoders-configuration": "Failed getting encoders configuration",
	"failed-getting-equipment-info": "Failed getting equipment info",
	"failed-getting-equipment-list": "Failed getting equipment list",
	"failed-getting-equipment-protocol-config": "Failed getting equipment protocol configuration",
	"failed-getting-list-of-available-files": "Failed getting list of available files",
	"failed-getting-list-of-lorawan-codecs": "Failed getting list of LoRaWAN codecs",
	"failed-getting-lon-types": "Failed getting LON SNVT Types from API",
	"failed-getting-notifications": "Benachrichtigung fehlgeschlagen",
	"failed-getting-orgaizations": "Failed getting organizations",
	"failed-getting-organization": "Failed getting organization",
	"failed-getting-properties": "Abruf von Datenpunkten fehlgeschlagen",
	"failed-getting-property-last-value": "Fehler beim Abrufen des zuletzt festgelegten Werts des Datenpunktes",
	"failed-getting-your-profile": "Profilabruf fehlgeschlagen",
	"failed-importing-configuration": "Failed importing configuration",
	"failed-inspecting-command-wait-please": "Failed inspecting command received by @.lower:box . Wait, please",
	"failed-loading-scan": "Failed loading scan",
	"failed-refreshing-scan": "Failed refreshing the Scan",
	"failed-request-scan": "Failed requesting the scan to the @.lower:box",
	"failed-reverting-sent-changes": "Failed reverting sent changes",
	"failed-saving-connector": "Failed saving connector",
	"failed-saving-gateway": "Failed saving gateway",
	"failed-saving-new-name": "Failed saving new name",
	"failed-saving-property": "Failed saving datapoint",
	"failed-saving-route": "Fehler beim Speichern der Route",
	"failed-saving-trigger": "Speichern des Triggers fehlgeschlagen",
	"failed-sending-license": "Failed sending license",
	"failed-setting-value": "Failed setting new value",
	"failed-updating-alarm-event": "Failed updating alarm event",
	"failed-updating-alarm-priority": "Failed updating alarm priority",
	"failed-updating-alarm-status": "Failed updating alarm status",
	"failed-updating-file": "Failed updating file",
	"failed-updating-organization": "Failed updating organization",
	"failed-updating-permission-not-authorized": "Failed updating permissions. You're not allowed to do that.",
	"failed-updating-properties-with-gateway-redirection": "Failed updating datapoints with gateway datapoints redirection",
	"failed-updating-user-password": "Failed updating password",
	"failed-updating-user-profile": "Failed updating user profile",
	"failed-uploading-file": "Failed uploading file",
	"failed-validating-equipment": "Failed validating equipment: {message}",
	"failed-validating-network": "Validierung des Netzwerks fehlgeschlagen: {message}",
	"field": "Field",
	"field-is-required": "Field {field} is required",
	"field-must-be-a-decimal": "Field {field} must be a decimal",
	"field-must-be-format": "Field must be in format: {format}",
	"field-must-have-x-digits": "Field must have at most {digit} decimal places",
	"field-should-be-between-values": "Field {field} should be between {min} and {max}",
	"field-should-be-number-or-null": "Field {field} should be a number or empty",
	"fields-are-required": "Not all fields are filled",
	"file": "Datei",
	"file-format": "Dateiformat",
	"file-saved": "Datei gespeichert",
	"file-too-big": "Datei ist zu groß",
	"file-too-big-size": "Datei ist zu groß und darf nicht {sizeMB} MB überschreiten",
	"file-type": "Typ",
	"file-visibility": "Dateisichtbarkeit",
	"filter": "Filter",
	"filters": "Filter",
	"final-url": "Endgültige URL",
	"find-equipment-want-to-connect-to-box": "Find the equipment you want to connect to the @.lower:box",
	"finished": "Finished",
	"finished-at": "Finished at",
	"firewall-disabled-allow-usb-connection": "The firewall is disabled to allow the USB connection",
	"first-visit": "Erster Besuch?",
	"for-each-character-of-the-identification-number-enter-a-digit-between-0-and-9-or-the-letter-F-for-any-digit": "Geben Sie für jedes Zeichen der Identifikationsnummer eine Ziffer zwischen 0 und 9 oder den Buchstaben „F“ für „beliebige Ziffer“ ein.",
	"forgot-password": "Forgot Password?",
	"format": "Format",
	"found": "Found",
	"free-form-date-label": "Startdatum oder Enddatum des Urlaubs",
	"free-form-date-optional-month-help": "Wenn der Monat nicht eingestellt ist, wiederholt sich der Feiertag jeden Monat an diesem Tag",
	"free-form-date-optional-year-help": "Wenn das Jahr nicht eingestellt ist, wiederholt sich der Feiertag jedes Jahr an diesem Tag",
	"free-form-date-time-help-msg-lpb": "Während des Urlaubs gilt der Schutzmodus oder der Urlaubsmodus.",
	"free-form-time-help": "Wenn die Minute oder/und die Sekunde nicht eingestellt sind, ist der Standardwert 0",
	"free-form-time-label": "Startzeit oder Endzeit des Urlaubs an diesem Tag",
	"frequency": "Frequency",
	"friday": "Friday",
	"from": "From",
	"from-bacnet-scan": "From BACnet Scan",
	"full-name": "Vollständiger Name",
	"full-scan-in-the-network": "Full scan in the network",
	"function": "Function",
	"gateway": "Gateway",
	"gateway-ip-address": "Gateway-IP-Adresse",
	"gateway-properties": "Gateway Datenpunkte",
	"gateway-properties-saved": "Gateway Datenpunkte gesichert",
	"gateway-saved": "Gateway gesichert",
	"general-settings": "Allgemeine Einstellungen",
	"german": "Deutsch",
	"go-to-box": "Go to the @.capitalize:client-name-box",
	"go-to-history": "Historie",
	"go-to-hub": "Go to the @.capitalize:client-name-hub",
	"go-to-properties-list": "Go to the properties configuration screen",
	"graph-name": "Name Diagramm",
	"graph.chart-type": "Chart type",
	"graph.export.selected-data": "Ausgewählte Daten",
	"graphs.apply-to-properties": "Apply to properties",
	"graphs.axe-y": "Axe Y",
	"graphs.convert-to-virtual-property": "Convert to virtual property",
	"graphs.marker": "Marker",
	"graphs.remove-property": "Remove property",
	"graphs.select-interval": "Select interval",
	"graphs.turns-into-interval-consommation": "Turn into interval",
	"group": "Gruppe",
	"group-address": "Gruppenadresse",
	"group-already-exists": "Gruppe existiert bereits.",
	"group-data-by": "Daten gruppieren nach",
	"group-equipment": "Gerätegruppierung",
	"groups": "Gruppen",
	"hang-in-there-we-are-loading-properties-and-can-take-some-minutes": "Bite warten Sie! Die Objekte werden geladen. Dies kann einige Minuten dauern!",
	"hardware": "Hardware",
	"heating-optimiser": "Heating Optimiser",
	"hide-side-panel": "Hide side panel",
	"higher-bound": "Higher bound",
	"history": "Historie",
	"hour": "Stunde",
	"hour-plural": "Stunde | Stunden",
	"hourly": "Stündlich",
	"hours": "Stunden",
	"how-to-address-equipment": "How to address the equipment",
	"how-to-find-hardware-id": "Wie finden Sie Ihre Hardware-ID?",
	"how-to-run-the-scan": "How to run the scan?",
	"hub": "@.clientname:_generic",
	"hub-configuration": "@.capitalize:hub Konfiguration",
	"hub-doesnt-have-current-configuration": "@.capitalize:hub hat keine aktuelle Konfiguration",
	"hub-offline": "@.capitalize:hub Offline",
	"hub-online": "@.capitalize:hub Online",
	"hub-status-checker": "@.capitalize:client-name-hub Statusprüfung",
	"hub-successfully-connected": "@.capitalize:client-name-hub erfolgreich verbunden",
	"hubs": "@.clientname:_generic-plural",
	"id-number": "ID Nummer",
	"identification-number": "Identifikationsnummer",
	"if-alert-notify-24-hours": "Auch wenn der Alarm mehrmals ausgelöst wird, sollten die Benachrichtigungen im Abstand von 24 Stunden erfolgen.",
	"if-alert-notify-X": "Auch wenn der Alarm mehrmals ausgelöst wird, halte die Benachrichtigungen {X} auseinander",
	"if-alert-notify-once": "Only when the alarm is triggered for the first time",
	"if-alert-notify-weekly": "Even if the alarm triggers multiple times, receive one notification per week",
	"if-box-located-europe": "Wenn sich @.lower:box in <strong>Europa</strong> befindet",
	"if-box-located-north-america": "Wenn sich @.lower:box in <strong>Nordamerika</strong> befindet",
	"if-cant-find-equipment-request-it-click": "Sollten Sie das Gerät nicht finden, klicken Sie hier um die Anforderung einzugeben!",
	"if-priotity-any-notify": "Egal wie schwerwiegend",
	"if-priotity-critical-notify": "Nur Kritisc",
	"if-priotity-standard-notify": "Nur Standard",
	"if-use-for-temporization": "Returns to normal incl.",
	"import-configuration": "Import configuration",
	"in": "in",
	"in-the-box": "Synchronized with the @.lower:box",
	"inactive-hub": "Inactive @.lower:hub",
	"indicate-a-digit-between-0-9-or-F-for-any-digit": "Geben Sie eine Ziffer zwischen 0 und 9 oder „F“ für „beliebige Ziffer“ an.",
	"indicate-period-in-days": "Zeitraum in Tagen angeben",
	"indicator-name": "Label",
	"individual-address": "Individual address",
	"individual-address-knx-lte-tooltip": "Individual address of KNX device to read. It has the following format #x.#y.#z where #x, #y and #z are positive numbers.",
	"individual-address-should-be-xyz": "Individual Address has the following format #x.#y.#z where #x, #y and #z are positive numbers",
	"inform-valid-email": "Inform a valid e-mail address",
	"insert-valid-name": "Insert a valid name",
	"instance": "Instance",
	"inter-frame-delay": "Inter Frame Delay",
	"inter-frame-delay-tooltip": "The delay in microseconds to wait after a frame is sent",
	"interface": "Schnittstelle",
	"internal": "Internal",
	"internal-address": "Interne Adresse",
	"internal-error-request-new-scan": "Ops! Our servers returned an internal error! Maybe request a new scan!",
	"internal-recipient": "Jemand von meiner Organisation",
	"internal-to-siemens": "Intern bei Siemens",
	"interval": "Intervall",
	"interval-s": "Interval (s)",
	"interval-seconds": "Interval (seconds)",
	"interval-seconds-tooltip": "The number of seconds between two polls of data. This is used by the @.lower:box when reading data from the equipment.",
	"invalid-ip-address": "Invalide IP Addresse",
	"invalid-phone-format": "Invalides Telefonnummer Format",
	"invalid-value-type": "Ungültiger Wertetyp",
	"iot": "IoT",
	"ip-address": "IP Addresse",
	"ip-address-of-gateway-non-mandatory": "The IP address of the gateway, non-mandatory",
	"ip-address-on-cird-notation": "The IP address on CIDR notation (XXX.XXX.XXX.XXX). The address given must be valid inside of your network. This field is required if the method is manual.",
	"ipv4-address": "IP Addresse",
	"ipv4-method": "IPv4 Methode",
	"it should-be-one-of-those-options": "It should be one of those options: {options}",
	"it-is-not-possible-specify-first-character": "Das erste Zeichen kann nicht geändert werden.",
	"it-will-be-deleted-when-configuration-sent-to-box": "It will be deleted when configuration is sent to the @.lower:box",
	"it-will-be-deleted-when-configuration-sent-to-box-connector": "The connector will be deleted when configuration is sent to the @.lower:box",
	"it-will-be-deleted-when-configuration-sent-to-box-equipment": "The equipment will be deleted when configuration is sent to the @.lower:box",
	"it-will-be-deleted-when-configuration-sent-to-box-gateway": "The gateway will be deleted when configuration is sent to the @.lower:box",
	"it-will-be-deleted-when-configuration-sent-to-box-network": "The network will be deleted when configuration is sent to the @.lower:box",
	"it-will-be-deleted-when-configuration-sent-to-box-property": "The datapoint will be deleted when configuration is sent to the @.lower:box",
	"keep-the-old-scan": "Behalten Sie den bisherigen Scan",
	"key": "Schlüssel",
	"key-name": "Schlüssel-Name",
	"key-sent-with-data-check-integrity-message": "Schlüssel, der mit den Daten gesendet wird, um die Integrität der Nachricht zu prüfen",
	"key-type": "Schlüssel-Typ",
	"key-value": "Schlüssel-Wert",
	"known": "Known",
	"knx-0-mode": "Komfort",
	"knx-1-mode": "Standby",
	"knx-2-mode": "Eco",
	"knx-3-mode": "Schutz",
	"knx-default-mode": "Standard",
	"language": "Sprache",
	"language-english": "Englisch",
	"language-french": "French",
	"language-german": "Deutsch",
	"last-7-days": "Letzten 7 Tage",
	"last-activation-event": "Letzten Wert erhalten am",
	"last-alert-at": "Letzte Meldung am",
	"last-digits-after--": "Letzte Ziffern nach -",
	"last-read-value-data": "Last value read: {value} {unit}{asterisk}",
	"last-token": "Letztes Zeichen",
	"last-value": "Letzter Wert",
	"last-value-receive": "Last value received",
	"last-values": "Letzen Werte",
	"last-written-value-data": "Last value written: {value} {unit}{asterisk}",
	"latest-configuration-from-console-advice-download-and-upload-here": "We noticed that the last configuration stored in your device has been generated from the web console. Before making changes from this interface, we advise you to download the configuration from the web console and upload it",
	"latest-configuration-from-da-advice-download-and-upload-here": "We noticed that the last configuration stored in your device has been generated from the Desktop Application. Before making changes from this interface, we advise you to download the configuration from the Desktop Application and upload it. Activating the data reception won't work otherwise",
	"latest-scan-dates-from-timestamp": "The latest scan dates from {timestamp}.",
	"launch-the-scan": "Launch the scan",
	"leave": "Verlassen",
	"leave-page": "Seite verlassen",
	"left": "Left",
	"left-ethernet-port": "Linker Ethernet Port",
	"license": "Lizenz",
	"license-sent-successfully": "Lizenz erfolgreich gesendet.",
	"licenses": "Lizenzen",
	"line": "Straight lines",
	"line-type": "Line type",
	"linux": "Linux",
	"list-boxes-in-scope-of-trigger": "Liste der @.lower:boxes im Geltungsbereich des Triggers",
	"list-of-addresses-1-to-255": "List of addresses (1 to 255)",
	"list-of-alarms": "List of alarms",
	"list-of-codes": "list of codes",
	"list-of-equipment": "List of equipment",
	"list-of-mask-addresses": "List of mask addresses",
	"live-data": "aktuelle Daten",
	"live-data-open-chart": "Grafik mit aktuellen Werten öffnen",
	"loading": "Loading",
	"loading-logs": "Loading logs",
	"loading-scan": "Loading scan",
	"loading-scan-can-take-up-to-x-minutes": "Loading scan. This can take up to {minutes} minutes",
	"location": "Standort",
	"login": "Login",
	"logout": "Logout",
	"logs": "Logs",
	"logs-events-msg": "Events are real time information sent by the device outside the sending of the datapoint values. They can help you getting a closer eye if you notice something unexpected. <a href=\"/list-events-code\"target=\"_blank\">See the list of event codes and their meaning</a><br />Example of events:<br />- 4004: the datapoint of the LoRaWAN equipment set to receive the downlink acknowledged its reception<br />- 5001: LoRaWAN payload decoding error<br />- 5004: LoRaWAN downlink request delivered<br />- 5005: LoRaWAN downlink request lost",
	"looks-dont-have-heating-optimiser-configured": "Looks like you don't have the Heating Optimiser configured.",
	"lorawan-quality-good": "Gut",
	"lorawan-quality-medium": "Mittel",
	"lorawan-quality-poor": "Schlecht",
	"lorawan-status-info-tooltip-txt": "<div class='lorawan-tooltip-txt'>Signal Strength Quality based on the table below <br /> <img src='{src}' /> <br />If RSSI and SNR indicators differ, we display the lowest indicator</div>",
	"lorawan-use-same-keys-msg": "Verwenden Sie die gleichen Tasten. Dies bedeutet, dass das Gerät auf das neue Gerät übertragen wird",
	"lower-bound": "Lower bound",
	"lpb-network-device-number-1-error": "Setting the device number to 1 means that the @.lower:box will be the device master on the segment which is not what the @.lower:box is intended for.",
	"maintenance-1h-at-X": "Am {date} ist für 1h eine Wartungsoperation auf der Konsole geplant. Der Dienst kann während dieser Zeit unterbrochen werden.",
	"maintenance-3h-at-X": "Am {date} ist für 3h eine Wartungsoperation auf der Konsole geplant. Der Dienst kann während dieser Zeit unterbrochen werden.",
	"make-sure-usb-cable-is-connected": "Make sure the USB cable is connected",
	"managed-by": "Managed by",
	"manufacturer": "Hersteller",
	"marker": "Marker",
	"marker-circle": "Kreis",
	"marker-cross": "Kreuz",
	"marker-none": "Kein",
	"marker-square": "Quadrat",
	"marker-triangle": "Dreieck",
	"mask": "Mask",
	"mask-address": "Mask address",
	"max-acceptable-value-is": "Der maximal akzeptable Wert ist {value}",
	"max-cpu-usage": "Max CPU Nutzung (%)",
	"max-data-points-reached": "Maximale Anzahl an Datenpunkt erreicht",
	"max-data-points-reached-hourly-computation-msg": "Aktuell senden Sie {current} Werte in einer Stunde , während Ihr aktueller Plan {max} zulässt. Bevor Sie die Konfiguration an Ihr Gerät senden, ändern Sie bitte entweder den Zeitintervall einiger Datenpunkte, oder deaktivieren Sie einige Datenpunkte. Sie können sich auch an Ihren Vertriebsmitarbeiter wenden, um die Gesamtzahl der Datenpunkte zu erhöhen.",
	"max-data-points-reached-msg": "In Bezug auf Ihre aktuelle Lizenz verwenden Sie {current} mehr als {max} Datenpunkte. Bevor Sie die Konfiguration an Ihr Gerät senden, deaktivieren Sie bitte einige Datenpunkte oder bitten Sie Ihren Vertriebsmitarbeiter, die Gesamtzahl Ihrer Datenpunkte zu erhöhen.",
	"max-ram-usage": "Max RAM Nutzung (MB)",
	"max-ram-usage-megabytes": "Die max. RAM Nutzung in MegaBytes",
	"maximum": "Maximum",
	"maximum-timer-redirect-to-mqtt-property-is-600-seconds": "Der Mindestintervall für einen Datenpunkt, das an ein MQTT-Gateway weitergeleitet wird, beträgt 600 Sekunden.",
	"maximum-value": "Max. Wert",
	"mbus-scan": "M-Bus-Scan",
	"measured-value": "Gemessener Wert",
	"message": "Nachricht",
	"method": "Methode",
	"metric": "Metrik",
	"minimum": "Minimum",
	"minimum-acceptable-value-is": "Der niedrigste akzeptierte Wert ist {value}",
	"minimum-value": "Min. Wert",
	"minute": "Minute",
	"minute-plural": "Minute | Minuten",
	"minutes": "Minuten",
	"missing": "WARNUNG",
	"missing-column-in-file": "Missing column(s) in the file: {column}",
	"modal.add-graph.title": "New or existing graph",
	"modbus-data-format-tooltip-explanation-endianness": "Floats and long integers do not fit in a single 16-bit register so consecutive registers are then used.<br/><br/>Because different manufacturers handle the endianness (order of the bytes) differently, you need to specify the byte order matching your ModBus equipment.",
	"modbus-ip-gateway-property": "Modbus TCP/IP Gateway Datenpunkt",
	"modbus-register-address-must-be-unique-msg": "The datapoint {propertyName} can’t use the address {address} and the function {functionName} as they are used by another datapoint",
	"mode": "Modus",
	"model": "Model",
	"monday": "Montag",
	"month": "Monat",
	"monthly": "Monatlich",
	"months": "Monate",
	"more-options": "Weitere Optionen",
	"mqtt-client-id-tooltip": "The clientId used to connect to MQTT",
	"mqtt-gateway-property": "MQTT Gateway Datenpunkt",
	"mqtt-qos": "Quality of Service (QoS)",
	"mqtt-qos-0": "0 - At most once delivery",
	"mqtt-qos-1": "1 - At least once delivery",
	"mqtt-qos-2": "2 - Exactly once delivery",
	"mqtt-server-host-placeholder": "MQTT server address",
	"mqtt-server-host-tooltip": "Remote MQTT Server address. A fully qualified domain name (FQDN) or an IP address. Max length is 253.",
	"mqtt-server-port-tooltip": "The remote MQTT server port",
	"mqtt-slug-fields-must-be-unique": "Slug names must be unique for every property, please include a unique field like datapoint ID or Unique ID",
	"mqtt-slug-tooltip": "A slug that will be used as identifier of the datapoint value on MQTT. If not set, the datapointId (that's automatically generated) will be used instead.",
	"mqtt-slug.property-description": "Beschreibung des Datenpunkts (die ersten 50 Zeichen)",
	"mqtt-version": "MQTT version",
	"mqtt-version-tooltip": "The MQTT version to use",
	"my-profile": "Mein Profil",
	"n-days-after": "{days} Tage danach",
	"name": "Name",
	"name-box-gateway-seen-in-bacnet-network": "Name der @.lower:box oder des Gateways, wie er im BACnet-Netz zu sehen sein wird. Wenn leer, wird der Wert aus dem Feld .\"Name\"angewendet.",
	"name-of-person": "Name der Person",
	"name-of-the-file": "Dateiname",
	"netmask": "Netzmaske",
	"network": "Netzwerk",
	"network-address": "Netzwerkadresse",
	"network-and-connector": "Netzwerk und Anschluss",
	"network-name": "Netzwerk Name",
	"network-number": "Netzwerk Nummer",
	"network-protocol-modbusip-help-msg": "Der physische Anschluss wird automatisch zugewiesen, wenn die Konfiguration an das Gerät gesendet und das Modbus-IP-Netzwerkkabel eingesteckt wird.",
	"networks": "Netzwerke",
	"neuron-id": "Neuron Id",
	"neuron-id-tooltip": "Beispiel einer Neuron ID: 07:02:73:DA:FC:00",
	"new": "Neue",
	"new-alarm": "Neuer Alarm",
	"new-configuration": "Neue Konfiguration",
	"new-configuration-not-applied-yet-to-box": "Die neue Konfiguration wurde noch nicht auf den @.lower:box angewendet",
	"new-configuration-will-overwrite-current-configuration-and-changes-wont-reflect-console": "Die neue Konfiguration überschreibt die aktuellen Daten. Die Änderungen werden nicht in der Konsole angezeigt.",
	"new-dashboard": "Neues Dashboard",
	"new-equipment-added-to-network": "Neues Gerät wurde dem Netzwerk hinzugefügt",
	"new-graph": "New graph",
	"new-group-name": "Name der neuen Gruppe",
	"new-password": "Neues Passwort",
	"new-recipient": "Neuer Empfänger",
	"new-value-not-set": "Neuer Wert konnte nicht gesetzt werden",
	"new-value-not-set-yet": "Neuer Wert konnte noch nicht gesetzt werden",
	"new-value-set-to-property": "Neuer Wert in Datenpunkt {property} geschrieben",
	"next": "Weiter",
	"next-day": "Nächster Tag",
	"next-period": "Next period",
	"no": "Nein",
	"no-authentication": "Keine Authentifikation",
	"no-codec": "No codec",
	"no-data-for-specific-dates": "Keine Daten für diesen Zeitraum verfügbar",
	"no-data-to-show": "Keine Daten",
	"no-devices-found-on-network-check-configuration": "No devices were found on the network. Please check your configuration and request a new scan",
	"no-line": "No line",
	"no-perm-dashboard-tooltip": "You do not have permissions to add a Dashboard",
	"no-properties": "No datapoints to display",
	"no-properties-click-to-add": "You don't have any properties yet. Click here to add it.",
	"no-properties-click-to-add-short": "You don't have any properties yet:",
	"no-redirections-message": "Dieser Datenpunkt leitet ihre Werte nicht um",
	"no-results": "No results",
	"no-selected-connector": "Connector not selected",
	"no-static-ip-set-to-usb-network": "There is not static IP set for the USB network adapter",
	"non-added": "non-added",
	"non-supported-object-type-and-instance": "Non-supported object type: {objectType}. <br />Instance: {objectInstance}",
	"none": "None",
	"not-available": "Nicht verfügbar",
	"not-configured": "not configured",
	"not-defined": "Nicht definiert",
	"not-in-box-send-configuration-to-save": "Not in the @.lower:box yet. Send the configuration to add it.",
	"not-in-box-send-configuration-to-save-connector": "This connector is not in the @.lower:box . Send the configuration to the @.lower:box to add it.",
	"not-in-box-send-configuration-to-save-equipment": "The equipment is not in the @.lower:box . Send the configuration to the @.lower:box to add it.",
	"not-in-box-send-configuration-to-save-gateway": "This gateway is not in the @.lower:box . Send the configuration to the @.lower:box to add it.",
	"not-in-box-send-configuration-to-save-network": "This network is not in the @.lower:box . Send the configuration to the @.lower:box to add it.",
	"not-in-box-send-configuration-to-save-property": "The datapoint is not in the @.lower:box . Send the configuration to the @.lower:box to add it.",
	"not-specified": "Nicht angegeben",
	"notification": "Notification",
	"notification-enable-temporization": "Benachrichtigung erhalten, wenn der Alarm wieder normal wird",
	"notification-type": "Benachrichtigungstyp",
	"notifications": "Benachrichtigung",
	"notify-by": "benachrichtigen durch",
	"number-of-items-to-read-in-array": "The number of items to read in an array",
	"nv-index": "NV Index",
	"object-index": "Objekt Index",
	"object-instance": "Objekt Instanz",
	"object-type": "Objekt Typ",
	"object-type-not-supported": "Objekttyp wird nicht unterstützt",
	"objects": "Objekte",
	"odd-months": "Ungerade Monate",
	"ok": "OK",
	"only-present-value-displayed-click-to-see-all-properties": "By default, only the \"Average Value\", \"Present Value\", \"Priority For Writing\" and \"Program State\" properties are listed below.",
	"open": "Offen",
	"open-alert": "Offen",
	"optimiser": "Optimiser",
	"optional": "Optional",
	"options": "Optionen",
	"options-for-endiannese-are": "Options for endianness are",
	"or": "ODER",
	"organization": "Organisation",
	"organization-prevent-rights-propagation": "Administratoren der übergeordneten Organisation autorisieren, Zugriff auf diese Organisation zu haben",
	"organization-prevent-rights-propagation-help": "Damit sich die Berechtigungen eines Benutzers von {parentName} auf diese (untergeordnete) Organisation erstrecken können, muss diese Einstellung aktiviert sein UND der Benutzer muss die Administratorberechtigung für {parentName} haben",
	"organization-saved": "Organisation gesichert",
	"organizations": "Organisationen",
	"organizations-managed-by": "Organisation verwaltet durch {name}",
	"origin": "Origin",
	"other": "Other",
	"other-info": "Weitere Info",
	"other-organizations": "Weitere Organisationen",
	"owner-organization": "Eigentümerorganisation",
	"pair-a-physical-device": "Physisches Gerät koppeln",
	"pair-the-device": "Gerät koppeln",
	"pair-with-physical-device": "Mit physischem Gerät koppeln",
	"panel-network.configure-network": "Netzwerk Konfigurieren",
	"panel-network.error-lon-ip-same-port": "Another LON IP network is already using the port {port}",
	"panel-network.placeholder-protocol": "Protokoll auswählen",
	"panel-property.warning.changes-in-draft": "The configuration shown below is the one present in the box.",
	"panel-property.warning.changes-in-draft.send": "It is has been edited, the changes are visible in '{startLink}Configuration{endLink}' . To apply the changes and view them on this screen, please send them to the box.",
	"panel-property.warning.changes-in-draft.title": "Changes in progress not synchronised with the box",
	"parent-box": "Parent @.capitalize:{'box'}",
	"parent-box-label": "Parent @.capitalize:{'box'}:",
	"parent-organization": "Elternorganisation",
	"parity": "Parität",
	"password": "Passwort",
	"passwords-do-not-match": "Passwords do not match",
	"payload": "Payload",
	"payload-prefix": "Payload prefix",
	"payload-prefix-when-writing-to-property-mandatory-when-access-write": "The payload prefix when writing to this datapoint. Mandatory when the access is in write.",
	"payment": "Payment",
	"period-after-incident-seconds": "Period after the incident in seconds",
	"period-in-days": "Zeitraum in Tagen",
	"period-in-minutes": "Zeitraum in Minuten",
	"period-in-seconds": "Zeitraum in Sekunden",
	"phone-number": "Telefonnummer",
	"physical-connector": "Phys. Anschluss",
	"physical-location-of-box": "Phys. Standort der @.lower:box",
	"please-wait-while-applying-configuration-hub": "Please wait while we are applying the configuration to your @.lower:hub",
	"plugin": "Plugin",
	"plugin-file": "Plugin file",
	"plugin-properties": "Plugin datapoints",
	"port": "Port",
	"port-to-expose-server-unique-per-physical-connector": "The port to expose the server on. This is unique per physical connector",
	"position-of-properties": "Select where to display the datapoints",
	"predicted-time": "Predicted time",
	"press-enter-to-deselect": "Eingabetaste zum Löschen betätigen",
	"press-enter-to-select": "Eingabetaste zur Auswahl betätigen",
	"previous": "Previous",
	"previous-period": "Previous period",
	"primary-address": "Primary Addresse",
	"priority": "Priorität",
	"priority-for-writing": "Priority for Writing",
	"private-key": "Privater Schlüssel",
	"program-id": "Program Id",
	"program-id-tooltip": "The id of the program",
	"properties": "Datenpunkte",
	"properties-added": "Datenpunkte hinzugefügt",
	"properties-duplicated-successfully": "Datenpunkte erfolgreich kopiert",
	"properties-references": "Datenpunkte References",
	"properties-saved": "Datenpunkte gespeichert",
	"properties-settings": "Datenpunkte Einstellungen",
	"properties-targeted-by-the-schedule": "Im Zeitplan vorgesehene Datenpunkte",
	"properties-updated": "Datenpunkte aktualisiert",
	"properties-values-in-an-hour": "Datenpunktwerte in einer Stunde",
	"property": "Datenpunkt",
	"property-already-saved": "Datenpunkt bereits gespeichert",
	"property-bacnet": "BACnet Property",
	"property-didnt-receive-any-value": "Dieser Datenpunkt hat noch keine Werte erhalten",
	"property-duplicated": "Datenpunkt kopiert",
	"property-id": "Datenpunkt ID",
	"property-index": "Datenpunkt Index",
	"property-is-redirected-confirm-rename": "Diese Eigenschaft wird an ein BACnet-IP- oder MQTT-Gateway weitergeleitet. Diese Gateways müssen möglicherweise aktualisiert werden, um Ihre Änderungen zu übernehmen. Möchten Sie die Änderungen auf die Gateways anwenden?",
	"property-kind": "Datenpunkttyp",
	"property-must-be-configured": "Datapoint {property} must be configured",
	"property-name": "Datenpunktname",
	"property-not-available-for-scaling": "Datapoint not available to be scaled",
	"property-not-saved-cant-be-empty": "{property} not saved: It can't be empty.",
	"property-plural": "Datenpunkt | Datenpunkte",
	"property-saved": "Datenpunkt gespeichert | Datenpunkte gespeichert",
	"property-slug": "Datapoint Slug",
	"property-slug-description": "Original equipment datapoint slug",
	"property-value": "Datenpunktwert",
	"protocol": "Protokoll",
	"provide-description-to-easily-identify-new-licence": "Geben Sie eine Beschreibung ein, um die neue Lizenz leicht zu identifizieren",
	"qtt-equipments-were-created": "{qtt} equipment were created",
	"qtt1-equipment-was-created": "1 equipment was created",
	"quality": "Qualität",
	"quantity": "Menge",
	"rate-plan": "Rate Plan",
	"rate-plan-deleted": "Lizenz gelöscht",
	"rate-plan-type": "Lizenztyp",
	"rate-plans": "Lizenzen",
	"raw-registers": "Raw registers",
	"reached-comfort-in": "Reached comfort in",
	"read": "Read",
	"read-and-write": "Read & Write",
	"read-and-write-desc": "Zulassen, dass die Werte aus der Cloud gelesen und geschrieben werden (Lesen und Schreiben)",
	"read-only": "Read Only",
	"read-only-desc": "Werte nur aus der Cloud lesen lassen (read only)",
	"read-write": "Read/Write",
	"reason": "Reason",
	"reasons": "Reasons",
	"received-at": "Received",
	"received-value-on-date": "Receveid value on {date}",
	"received-value-x-minutes-ago": "Received value {when}",
	"recipient": "Empfänger",
	"recipients": "Empfänger",
	"redirect-to-property": "Redirect to datapoint",
	"redirect-value-to": "Redirect value to: {to}",
	"redirecting-from": "Redirecting from",
	"redirecting-to": "Redirecting to",
	"redirections": "Redirections",
	"reference": "Reference",
	"references": "References",
	"refresh": "Aktualisieren",
	"refresh-scan": "Scan aktualisieren",
	"refresh-value": "Refresh value",
	"region": "Region",
	"register-address": "Register Addresse",
	"register-address-already-in-use": "Registeraddresse wird bereits verwendet",
	"register-type": "Register Typ",
	"relation-between-physical-logical-state-with-image": "<div class='bacnet-polarity-tooltip-txt'>Relation between physical and logical state of the value. <br /> <img src='{imgsrc}' /></div>",
	"release-version": "Release {version}",
	"remaining-properties": "Remaining datapoints",
	"reopen-alert": "Reopen the alert",
	"repeat-every": "Repeat every",
	"repeat-new-password": "Repeat your new password",
	"request-autodiscovery-box": "Requesting scan to the @.lower:box",
	"request-download": "Request Download",
	"request-new-scan": "Request new scan",
	"requested-by": "Requested by",
	"requesting-scan": "Requesting Scan",
	"required": "Required",
	"required-when-communicating-lte-mode-if-device-supports-s-and-lte-modes-has-to-set": "Required only when communicating in LTE mode. If a device supports both S and LTE modes, this has to be set.",
	"reset-time": "Reset time",
	"resource-uri": "Ressourcen-URI",
	"resources": "Ressourcen",
	"response-timeout": "Response timeout",
	"response-timeout-tooltip": "Request response timeout in microseconds",
	"restart": "Neustart",
	"restart-app-error": "Please, restart the application. Something went wrong, sorry.",
	"restart-app-msg": "Hold on, please. We're trying to reconnect to Back-end service.",
	"restarting-server-failure-msg": "Please, close and open again the application",
	"restarting-server-please-wait": "Please wait... this can take some minutes.",
	"restarting-server-title": "We are applying your license and setting up the app.",
	"results": "Results",
	"retry-number": "Retry number",
	"retry-number-tooltip": "The number of retries if the request was lost",
	"return-to-normal": "Zurück zur Normalität",
	"right": "Right",
	"right-ethernet-port": "Rechter Ethernet Port",
	"role": "Rolle",
	"roles.box-permissions": "@.capitalize:box permissions",
	"roles.custom-rights": "Custom rights",
	"roles.integrator": "Integrator",
	"roles.maintenance-technician": "Maintenance Technician",
	"roles.no-access": "Kein Zugriff",
	"roles.organization-admin": "Organisation Admin",
	"roles.read-only-user": "Read Only Nutzer",
	"roles.site-manager": "Site Manager",
	"roles.software-integrator": "Software Integrator",
	"route-deleted": "Route gelöscht",
	"route-saved": "Route gespeichert",
	"route-valid-success-msg": "Die neue Route ist gültig",
	"routing": "Routing",
	"routing-metric-help": "Priorität der Route bei Konflikten. Je niedriger der Wert, desto höher die Priorität",
	"routing-table-msg": "Ihr Gateway enthält eine Routing-Tabelle mit Standardrouten für die Kommunikation mit der Konsole. Wenn Ihre Netzwerkkonfiguration die Definition bestimmter Routen erfordert oder wenn Routen von ihrem Standardrouting umgeleitet werden müssen, können Sie neue Routen hinzufügen. Diese wirken sich nicht auf die Standardtabelle aus.",
	"routing-table-success-msg": "Die Routing-Tabelle ist gültig",
	"run-mbus-scan": "M-Bus-Scan ausführen",
	"run-optimiser-wizard": "Run Optimiser wizard",
	"rvl-OFF-mode": "REDUCED",
	"rvl-ON-mode": "NORMAL",
	"rvl-migration-click-to-update": "Klicken Sie hier, um den Update-Vorgang auszulösen",
	"rvl-migration-needed-msg": "Mindestens ein Gerät vom Typ RVL ist mit Ihren Geräten verbunden. Es wurde eine neue Funktion veröffentlicht, um das Lesen und Schreiben von Zeitplänen auf solchen Geräten zu vereinfachen. Wir können Ihre Konfiguration in Ihrem Namen aktualisieren, damit Sie davon profitieren. Wenn das Update abgeschlossen ist, wird diese Meldung nicht mehr angezeigt.",
	"rvl-migration-success": "Ihr Gerät wurde in die Update-Warteschlange aufgenommen",
	"same-day": "Same day",
	"saturday": "Samstag",
	"save": "Speichern",
	"save-all-properties-qtt": "Save all datapoints | Save all {qtt} datapoints",
	"save-all-selected-properties": "Sollen die ausgewählte Datenpunkte gespeichert werden?",
	"save-all-selected-properties-or-selected-properties-from-current-equipment": "Sollen alle Datenpunkte gespeichert werden oder nur die ausgewählten Datenpunkte von {equipment}?",
	"save-changes": "Änderungen speichern",
	"save-properties": "Save properties",
	"save-qtt-properties-from-equipment": "Save {qtt} datapoints from {equipment}",
	"save-selected-boxes": "Ausgewählte @.lower:boxes speichern",
	"save-selected-properties": "Ausgewählte Datenpunkte speichern",
	"saved": "Gespeichert",
	"saved-graphs": "Diagram gespeichert",
	"scaled-value": "Wert",
	"scaling": "Skalierung",
	"scaling-explanation": "Wenden Sie die Skalierung an, um den Datenpunkt durch Multiplikation mit einem Faktor a (Beispiel: 1, 10, 0,1) und/oder durch Addition eines Wertes b (Beispiel: 1000, -50) zu verändern.",
	"scaling-explanation-gateway": "A scaling is applied on the equipment property. It is also applied on the redirected property. You can change the scaling formula in the equipement property configuration.",
	"scan": "Scan",
	"scan-bacnet-network": "BACnet-Netzwerk scannen",
	"scan-date": "Scan Datum: {date}",
	"scan-discovery": "Scan BACnet",
	"scan-mbus-network": "M-Bus-Netzwerk scannen",
	"scan-no-results-msg": "Der Scan hat keine Ergebnisse gebracht.",
	"scan-not-found": "Scan nicht gefunden",
	"scan-not-found-please-request-one": "Scan not found. Please, request one.",
	"scan-options": "Scan Optionen",
	"scan-progress": "Scan Verlauf",
	"scan-requested-on-timestamp-want-to-use": "You have a scan that was requested on {timestamp}. Do you want to use it?",
	"scan-still-in-progress-longer-than-15-minutes-stop-and-request-new-one": "Der Scan wird noch ausgeführt, aber seit der letzten Aktualisierung sind mehr als 15 Minuten vergangen. Sie können es stoppen und den Scan neu starten.",
	"scan-still-in-progress-longer-than-x-minutes-stop-and-request-new-one": "Der Scan wird noch ausgeführt, aber seit der letzten Aktualisierung sind mehr als {minutes} Minuten vergangen. Sie können es stoppen und ein neues anfordern.",
	"scanning-hub-please-wait": "Scanning @.lower:{'hub'}. Please wait...",
	"scatter-plot": "Scatter plot",
	"scenario": "Szenario",
	"schedule": "Zeitplan",
	"schedule-last-value-tooltip": "Expected value based on the schedule configuration",
	"schedule-management-encoder": "Schedule manager encoder",
	"schematic": "Dashboard",
	"schematic-drag-image-here": "Schematic\n\nDrag & Drop an image \n\nPNG, JPEG",
	"scopes": "Scopes",
	"search": "Suche",
	"search-for-a-box": "Suche nach @.lower:box",
	"search-for-a-device": "Suche nach einem Gerät (Name, Geräte-ID oder Hardware-ID)",
	"search-for-a-property": "Suche nach Datenpunkten",
	"search-for-a-recipient": "Suche nach Empfänger",
	"search-for-alarms": "Suche nach Alarmen",
	"search-for-an-equipment": "Suche nach Geräten",
	"search-for-archive-requests": "Suche nach Datenarchiven",
	"search-for-hub": "Suche nach einem @.lower:hub (Name, Geräte Id oderr Hardware Id)",
	"search-for-organization-name": "Suche nach dem Namen einer Organisation",
	"second": "Zweite",
	"second-plural": "Zweiter | Sekunden",
	"secondary-address": "Secondary address",
	"secondary-address-mbus-tooltip": "Secondary address of the equipment. Format: 16 uppercase hexadecimal caracters",
	"seconds-symbol": "sek",
	"secret-key": "Geheimer Schlüssel",
	"security": "Security",
	"security-key": "Security Key",
	"see-details": "Siehe Details",
	"see-last-values": "See last values",
	"see-more": "Mehr dazu",
	"see-redirection-property": "See where the property is redirected to",
	"see-the-former-scan": "See the former scan",
	"segment-number": "Segmentnummer",
	"segment-number-description": "Die Segmentnummer des LPB-Geräts",
	"select": "Auswahl",
	"select-a-connector": "Wählen Sie einen Konnektor aus",
	"select-an-alarm": "Alarm auswählen",
	"select-an-equipment": "Gerät auswählen",
	"select-and-configure-box-ethertnet-connector": "Wählen und konfigurieren Sie den Ethernet-Anschluss.",
	"select-at-least-one-property": "Sie müssen mindestens einen Datenpunkt auswählen",
	"select-at-least-one-weekday": "Sie müssen mindestens einen Wochentag auswählen",
	"select-box-or-hub-for-file": "Wählen Sie die @.lower:box für die Datei",
	"select-date": "Datum auswählen",
	"select-date-range": "Zeitraum auswählen",
	"select-equipment-left-column-list-properties": "Wählen Sie ein Gerät in der linken Spalte, um alle verfügbaren Datenpunkt aufzulisten",
	"select-file-format": "Dateiformat auswählen",
	"select-file-visibility": "Dateisichtbarkeit auswählen",
	"select-frequency-receive-notification": "Wählen Sie die Häufigkeit, mit der Sie Benachrichtigungen erhalten möchten",
	"select-graph": "Select the graph",
	"select-hubs-to-export-configuration": "Select which @.lower:hubs you would like to export the configuration",
	"select-notification-type": "Select notification type",
	"select-organization-fot-file": "Organisation für die Datei auswählen",
	"select-organization-to-see-connectors-or-to-create-new": "Wählen Sie eine Organisation aus, um ihre Verbindungen anzuzeigen oder eine neue zu erstellen",
	"select-properties": "Datenpunkt auswählen",
	"select-properties-to-activate": "Datenpunkt zur Aktivierung auswählen",
	"select-properties-to-redirect-to-gateway": "Datenpunkt auswählen, welcher an das Gateway weiterlgeleitet warden soll; konfigurieren und Speicher Sie.",
	"select-property-to-apply-interval": "Select property to apply the interval",
	"select-region-and-frequency-for-sensors": "Select the region (if available) and the frequency for sensors.",
	"select-region-for-lorawan-equipment": "Select one of the supported regions for the LoRaWAN equipment",
	"select-region-frequency-equipment-is-installed": "Select the Region and Frequency where your equipment is installed",
	"select-rvl-equipment": "RVL Gerät auswählen",
	"select-the-properties": "Datenpunkte auswählen",
	"select-the-region": "Region auswählen",
	"select-the-user-to-send-the-license-by-email": "Select the user to send the license by e-mail",
	"select-which-address-run-scan": "Select on which address you want to run the scan",
	"selected": "Selected",
	"selected-properties": "Ausgewählte Datenpunkte",
	"send": "Senden",
	"send-archive-to": "Archiv versenden an",
	"send-configuration-to-hub": "Send the configuration to the @.lower:hub",
	"send-configuration-to-the-box": "Send configuration to the @.lower:box",
	"send-license": "Send license",
	"send-license-by-email": "Lizenz per E-Mail versenden",
	"send-new-configuration-to-the-box": "Send new configuration to the @.lower:box",
	"send-the-configuration": "Send the configuration",
	"send-updates-to-device": "Check to send the changes to the box after saving",
	"send-updates-to-device-infos": "If you have several changes to make, tick this box before saving the last change.",
	"sending-frequency": "Sendefrequenz",
	"sending-notifications": "Häufigkeit",
	"sent-configuration-to-box-msg": "Saving and applying configration to the @.lower:{'box'}. Wait, please.",
	"separator": "Separator",
	"separator-space-or-comma": "Separator: space or comma",
	"serial-number": "Seriennummer",
	"server-host": "Server Host",
	"server-port": "Server Port",
	"service-account": "Service Account",
	"service-account-updated": "Successfully updated service account",
	"set-out-of-service": "Deaktivieren Sie diesen Feiertag",
	"set-to-null": "Set to null",
	"set-value": "Set a value",
	"set-value-to-property": "Einen Wert dem Datenpunkt zuweisen",
	"settings": "Einstellungen",
	"severity": "Schweregrad",
	"severity-level-to-apply-to-alerts-when-created": "Schweregrad, der für die erzeugten Warnungen gelten soll",
	"show-advanced-properties": "Erweiterte Datenpunkte anzeigen",
	"show-all-properties": "Alle Datenpunkte anzeigen",
	"show-hide-default-values-in-calendar": "Show/hide default values in calendar. For atlantic_navipass_weekly, the default value is OFF. For bacnet, you setup the value on configurations.",
	"show-more-organization": "Show more organization",
	"show-side-panel": "Show side panel",
	"sidebar-menu-item.company": "Organisation",
	"sidebar-menu-item.map": "Standorte",
	"signal": "Signal",
	"signal-strength": "Signal Strength",
	"skip-this-step": "Skip this step",
	"slave-id": "Slave Id",
	"slave-id-modbus-gateway": "The slave id of this modbus gateway",
	"slot": "Steckplatz",
	"slots": "Slots",
	"slug-name": "Slug name",
	"sms": "SMS",
	"sms-to": "SMS to",
	"snvt-type-index": "SNVT Type Index",
	"software": "Software",
	"some-fields-are-invalid": "Some fields are invalid",
	"some-fields-are-required": "Some fields are required",
	"something-went-wrong": "Something went wrong",
	"something-went-wrong-our-side-try-again": "Something went wrong in our side. Try again.",
	"something-went-wrong-try-again": "Something went wrong in our side. Try again.",
	"sort-by": "Sortiert nach",
	"specific-mask-address": "Specific mask address",
	"spreading-factor": "Spreading Factor",
	"standard": "Standard",
	"start": "Start",
	"start-again": "Erneut starten",
	"start-date": "Start Datum",
	"start-index": "Start Index",
	"start-time": "Startzeit",
	"started-at": "Gestartet am",
	"starting-time": "Startzeit",
	"state-schedule-object-click-see-full-json": "State of the Schedule object. Click here to see the full schedule in a JSON format",
	"status": "Status",
	"status-down": "Status: Down",
	"status-for-connector-not-available": "The status for this connector is not available",
	"status-missing": "Missing Data",
	"status-ok": "Status: OK",
	"stay": "Bleiben",
	"stay-at-this-page": "Bleib",
	"step-line": "Schritte",
	"stop-bits": "Stop bits",
	"stop-reception-property-data": "Stop the reception of datapoint values",
	"strict-ranges": "Strict ranges",
	"sub-field": "Sub-field",
	"sub-field-tooltip": "The path to the field to extract from the structure. The path has to be in the form: first Level Structure.second Level Structure....subfield, this will extract the value of subfield from its parent structure, regardless of the depth of the structure.",
	"subscription": "Abonnement",
	"success-creating-organization": "Erfolg schafft neue Organisation",
	"success-editing-organization": "Erfolg aktualisierende Organisation",
	"successfully-added-properties": "Sie haben die Datenpunkte erfolgreich hinzugefügt",
	"successfully-dashboard": "Dashboard erfolgreich gespeichert",
	"successfully-saved-graph": "Grafik erfolgreoch gespeichert",
	"successfully-updated": "Erfolgreich aktualisiert",
	"summary": "Zusammenfassung",
	"sunday": "Sonntag",
	"support-contact": "Kontaktieren Sie das Support-Team",
	"support-forum": "Help Center",
	"supported-frequencies": "Supported frequencies",
	"sync": "Sync.",
	"synchronized": "Synchronisiert",
	"synco-exception-day": "Zeitplan am 8. Tag festgelegt (Ausnahmezeitplan)",
	"synco-exception-disable-text": "Ausnahme deaktivieren",
	"synco-exception-disable-text-help": "Wenn Sie die Ausnahme deaktivieren, setzt das Gerät die Ausnahmedetails auf null zurück",
	"synco-exception-end-day-label": "Ende am (enthalten)",
	"synco-exception-help-msg": "Da das Gerät vom Typ Synco ist, seien Sie bitte vorsichtig beim Bearbeiten von Ausnahmen. Wenn eine Ausnahme deaktiviert ist, kann diese Ausnahme einem anderen Datenpunkt zugeordnet werden. Lesen Sie daher bitte die verschiedenen Ausnahmen, bevor Sie eine davon bearbeiten",
	"synco-exception-invalid-range": "Die Start- und Endtage müssen kohärent sein",
	"synco-exception-period": "REDUCED-Modus oder PROTECTION-Modus (Eco-Modus)",
	"synco-exception-start-day-label": "Start am",
	"synco-exception-type": "Zeitplan zur Anwendung während der Ausnahme",
	"system-lorawan-property-tooltip": "Dieser Datenpunkt wird nicht zu den in Ihrem Abonnement verfügbaren Datenpunkten gezählt",
	"table": "Tabelle",
	"table-block-label-a": "Überschrift Spalte A",
	"table-block-label-b": "Überschrift Spalte B",
	"table-block-label-c": "Überschrift Spalte C",
	"table-block-nb-of-columns": "Anzahl der Spalten (A, B, C...)",
	"table-block-nb-of-rows": "Anzahl der Zeilen (1, 2, 3...)",
	"table-block-title-1": "Beschriftung Zeile 1",
	"table-block-title-2": "Beschriftung Zeile 2",
	"table-block-title-3": "Beschriftung Zeile 3",
	"tabs.organization.devices": "Gerät",
	"tag-can-start-with-ws": "The key of a tag can't start with ws_",
	"tag-key-cant-be-empty": "The key of a tag can't be empty",
	"tags": "Tags",
	"target": "Ziel",
	"tcp-port": "TCP Port",
	"technical-contact": "Technischer Ansprechpartner",
	"telephone-number": "Telefonnummer",
	"test-in-progress": "Test läuft",
	"test-route": "Route testen",
	"test-routing-table": "Routing-Tabelle testen",
	"the-certificate-has-to-be-of-type-MQTT_CA_CERTIFICATE": "The certificate has to be of type MQTT_CA_CERTIFICATE",
	"the-certificate-has-to-be-type-MQTT_CLIENT_CERTIFICATE": "The certificate has to be of type MQTT_CLIENT_CERTIFICATE",
	"the-certificate-has-type-MQTT_PRIVATE_KEY": "The certificate has to be of type MQTT_PRIVATE_KEY",
	"the-end-customer": "Für den Endkunden",
	"the-max-cpu-usage-percent": "The max CPU usage in percent",
	"the-new-scan-in-progress-while-is-completed-do-you-want-see-former-scan-new-scan-results-will-shown-when-over": "Der neue Scanvorgang ist im Gange. Möchten Sie die Ergebnisse des vorherigen Scans sehen, bis der Scan abgeschlossen ist? Die neuen Scanergebnisse werden angezeigt, sobald der Scan abgeschlossen ist.",
	"the-new-scan-is-over-do-you-want-to-load-its-results": "Der neue Scan ist beendet. Möchten Sie die Ergebnisse laden?",
	"the-number-of-registers-to-read-write": "The number of registers to read/write",
	"the-port-network-will-list": "The port on which this network will listen.",
	"the-trigger-will-execute-only-for-boxes-listed-below": "Der Trigger wird nur für die unten aufgeführten @.lower:boxes ausgeführt",
	"the-type-of-the-register-to-use": "The type of register to use",
	"the-value-is-not-a-valid-URL-address": "Der Wert ist keine gültige URL-Adresse",
	"this-connector-doesnt-have-any-trigger": "Dieser Anschluss hat noch keine Trigger",
	"this-device-does-not-have-access-to-heating-optimizer": "This @.lower:box does not have access to Heating Optimizer. Contact support, please.",
	"this-property-isnt-receiving-any-redirections": "This datapoint isn't receiving any redirections",
	"this-property-isnt-redirecting-its-values": "This datapoint isn't redirecting its values",
	"this-property-receives-values-from-properties-listed-below": "This datapoint receives values from the datapoints listed below",
	"this-property-will-redirect-all-values-to-properties-listed-below": "This datapoint will redirect all values to the datapoints listed below",
	"this-will-archive-connecor-and-triggers-attached-you-will-no-longer-receive-data-through-the-connector": "Dies archiviert \"{connector}\" sowie die mit ihm verbundenen Trigger, falls vorhanden. Sie werden keine Daten mehr über den Anschluss erhalten.",
	"this-will-delete-x-properties-from-gateway": "Dadurch wird 1 Datenpunk aus dem Gateway gelöscht | Dadurch werden {x} Datenpunkte aus dem Gateway gelöscht",
	"this-will-delete-x-properties-past-values-will-be-deleted": "Dadurch wird 1 Datenpunkt gelöscht. Alle früheren Werte des Datenpunktes werden gelöscht. | Dadurch werden {x} Datenpunkte gelöscht . Alle bisherigen Werte der Datenpunkte werden gelöscht.",
	"thursday": "Donnerstag",
	"tile-alone": "Einzelwert",
	"tile-configuration-link": "Datenpunkt konfigurieren",
	"tile-history-link": "See the latest values",
	"time": "Zeit",
	"time-to-reach": "Time to reach comfort",
	"tls-certificate": "TLS Zertifikat",
	"to": "An",
	"to-create-data-stream-have-at-least-one-connector-one-trigger-connectors-specify-link-infrastructures": "Um einen Datenstrom zu erstellen, z. B. einen Webhook oder eine Cloud-zu-Cloud-MQTT-Verbindung, müssen Sie mindestens einen Anschluss und einen Trigger deklarieren. \nKonnektoren spezifizieren die Verbindung zu Ihrer Infrastruktur.",
	"to-list-equipment-properties-available-select-box-connector": "To list all equipment's available properties, select the @.lower:box connector.",
	"toast.alarm-saved": "Alarm gespeichert",
	"toast.hub-received-command": "@.capitalize:client-name-hub received the command",
	"toast.scan-bacnet-devices-in-progress-percentage": "Scan der BACnet-Geräte läuft ({percentage}%)",
	"toast.waiting-for-hardware-connection": "Trying to connect the @.capitalize:client-name-hub to our server, please wait",
	"toast.weekly-schedule.days-copied-successfully": "Der Zeitplan wurde erfolgreich auf die ausgewählten Tage angewendet",
	"today": "Heute",
	"token-validity-period": "Token-Gültigkeitsdauer",
	"tooltip-alarm-status": "<strong class='has-text-white'>Acknowledge</strong>: indicate the alarm as \"seen\". No new notification will be sent unless the alarm is triggered again after 24 hours <br /><br /> <strong class='has-text-white'>Reopen</strong>: the alarm will be opened again. Does not change the status of alerts associated with the alarm",
	"tooltip-wmbus-device-type": "2 characters hex string found on the device label or documentation",
	"tooltip-wmbus-dib": "Concatenate both DIFs and DIFEs in hexadecimal. Example: with DIF=01 DIF=02 DIFE=03 DIFE=04, use 01020304",
	"tooltip-wmbus-encryption": "Whether the device uses encryption (A profile)",
	"tooltip-wmbus-id-number": "Also called \"Serial Number\", 8 digits number found on the device label",
	"tooltip-wmbus-mode": "Listening to wM-Bus sensors of this mode, use \"T & C\"if you have both T and C sensors",
	"tooltip-wmbus-physical-connector": "wM-Bus and LoRaWAN use the same physical connector",
	"tooltip-wmbus-version-number": "Also called \"Protocol Version\", 2 characters hex string found on the device label or documentation",
	"tooltip-wmbus-vib": "Concatenate both VIFs and VIFEs in hexadecimal. Example: with VIF=01 VIF=02 VIFE=03 VIFE=04, use 01020304",
	"tooltip.advanced-config-error": "Um Geräte zu erstellen, bearbeiten Sie die Konfiguration.",
	"tooltip.bacnetscan.select-device-to-add-properties": "Wählen Sie das Gerät aus, um die verfügbaren Datenpunkte anzuzeigen",
	"tooltip.bacnetscan.total-raw-properties": "Alle Datenpunkt gescant",
	"tooltip.bacnetscan.total-selectable-properties": "auswählbare Datenpunkte",
	"tooltip.bacnetscan.total-selected-properties": "Aktuell ausgewählter Datenpunkte",
	"tooltip.edit-advanced-config": "erweiterte Konfiguration editieren",
	"tooltip.last-read-value-data-time": "Last value read: {value} {unit}{asterisk} on {dateTime}",
	"tooltip.last-written-value-data-time": "Last value written via the console by a user: {value} {unit}{asterisk} on {dateTime}",
	"tooltip.satellite-rate-plan.parent-box": "You are activating a @.lower:box with a Satellite license. You must define a parent @.lower:box with a Medium or Large license, located on the same site, and activated. Your satellite @.lower:box will be attached to the parent @.lower:{'box'}.",
	"total-properties": "Alle Datenpunkte:",
	"trigger-alert-based-on": "Trigger",
	"trigger-saved": "Trigger gespeichert",
	"trigger-type": "Triggertyp",
	"triggers-define-required-call-connector-and-what-values-send": "Trigger definieren, was zum Aufrufen des Konnektors erforderlich ist und welche Werte gesendet werden sollen.",
	"try-again": "Erneut versuchen",
	"tuesday": "Dienstag",
	"type": "Typ",
	"type-licence-to-attach-to-device": "Typ der Lizenz, die an das Gerät angehängt werden soll",
	"udp-port": "UDP Port",
	"unique-id": "Unique ID",
	"unit": "Einheit",
	"unknown": "Unknown",
	"update": "Update",
	"update-hub": "@.capitalize:hub aktualisieren",
	"update-name": "Änderungen auf die Gateways anwenden",
	"update-name-equipment-in-gateway": "Den neuen Namen in den Gateways verwenden",
	"update-property-changes-in-gateway": "Eigenschaftsänderungen auf die Gateways anwenden",
	"update-the-scan": "Update Scan",
	"update-the-trigger": "Aktualisieren Sie den Trigger",
	"update-your-password": "Passwort aktualisieren",
	"updated": "Aktualisiert",
	"uplink-topic": "Uplink topic",
	"uplink-topic-for-alarms": "Uplink-Thema für Alarme",
	"uplink-topic-for-events": "Uplink-Thema für Veranstaltungen",
	"uplink-topic-for-values": "Uplink-Thema für Werte",
	"upload-configuration": "Upload Konfiguration",
	"upload-configuration-will-delete-current-after-send-hub": "Uploading a new configuration to {deviceName} will delete and replace its current configuration after it is sent to the @.lower:hub",
	"url": "URL",
	"use-mask-identification-number": "Verwenden Sie eine Maske für die Identifikationsnummer",
	"use-old-scan": "Alten Scan verwenden",
	"use-previous-scan": "Use this scan",
	"user": "Benutzer",
	"user-information": "Benutzerinformation",
	"user-management": "Benutzerverwaltung",
	"user-profile": "Benutzerprofil",
	"user-profile-updated-with-success": "Erfolgreich aktualisiertes Benutzerprofil",
	"user-saved": "Benutzer gespeichert",
	"username": "Benutzername",
	"username-used-in-the-authentication": "Der bei der Authentifizierung verwendete Benutzername",
	"validator.check-your-email-address": "Überprüfen Sie Ihre E-Mail-Adresse",
	"value": "Wert",
	"value-before-last-value": "Previous value received on:",
	"value-from-property-at-scan-time": "Value of the datapoint at the moment of the scan {time}",
	"value-most-not-have-more-than-characters": "Value must not have more than {length} characters",
	"value-must-be-a-decimal": "Value must be a decimal",
	"value-must-be-an-integer": "Value must be an integer",
	"value-must-be-between": "Value must be between {min} and {max}",
	"value-must-be-numeric": "Value must be numeric",
	"value-must-have-at-least-characters": "Value must have at least {length} characters",
	"value-must-have-x-characters": "Value must have {characters} characters",
	"value-not-accepted": "Wert nicht akzeptiert",
	"value-of-nv-index": "The value of NV Index",
	"value-of-snvt-type-index": "The value of SNVT Type Index",
	"value-should-be": "Value should be {value}",
	"value-type-function": "Value type (function)",
	"values-route": "Werteroute",
	"values-url": "Werte-URL",
	"vendor-specific-apn-link": "The vendor specific APN link",
	"verifiation-code": "Bestätigungscode",
	"version": "Version",
	"version-number": "Versionsnummer",
	"views.account-settings.views.service-accounts.service-accounts.add-service-account": "Create service account",
	"views.account-settings.views.service-accounts.views.service-account.description": "Description",
	"views.account-settings.views.service-accounts.views.service-account.username": "Username",
	"views.account-settings.views.users.users.failed-get-users": "Failed getting list of users.",
	"views.auth.activation.backlogin": "Melden Sie sich hier an",
	"views.auth.activation.backlogin.question": "Haben Sie bereits ein Konto ?",
	"views.auth.activation.confidential": "Durch die Aktivierung meines Kontos akzeptiere ich ",
	"views.auth.activation.confidential-underline": "die Datenschutzrichtlinie und die Nutzungsbedingungen.",
	"views.auth.activation.failed-account": "Wenn Ihr Konto bereits vorhanden ist",
	"views.auth.activation.failed-account-backLogin": "hier einloggen",
	"views.auth.activation.failed-username-point1": "Überprüfen Sie Ihre E-Mail-Adresse",
	"views.auth.activation.introduction": "Ist dies das erste Mal, dass Sie auf die Konsole zugreifen? Beginnen Sie damit, Ihr Konto zu aktivieren.",
	"views.auth.activation.log-to-proceed": "Ihr Konto aktivieren",
	"views.auth.activation.opt-in-newsletter": "Receive information about new features via email (1 per quarter).",
	"views.auth.activation.optin": "Erhalten Sie Informationen über neue Funktionen per E-Mail (1 pro Quartal).",
	"views.auth.email-sent-with-link-reset-password": "Der Link zum Zurücksetzen des Passworts wurde an die bekannte E-Mail versendet!",
	"views.auth.inform-valid-email": "Geben Sie eine gültige E-Mail Adresse ein",
	"views.auth.login.failed-account": "Wenn dies Ihr erster Besuch ist, ",
	"views.auth.login.failed-account-backActivation": "aktivieren Sie Ihr Konto hier",
	"views.auth.login.failed-login": "Ops! Log-in fehlgeschlagen! Prüfen Sie Ihre Anmeldedaten!",
	"views.auth.login.failed-username-point1": "Korrigieren Sie Ihre E-Mail-Adresse oder Ihr Passwort",
	"views.auth.login.log-to-proceed": "Bitte loggen Sie sich in Ihr Konto ein",
	"views.auth.login.password": "Passwort",
	"views.auth.login.password-confirm": "Passwort bestätigen",
	"views.auth.login.password-min-8-chars": "Ihr Passwort ist zu kurz, bitte verwenden Sie mindestens 8 Zeichen",
	"views.auth.login.passwords-dont-match": "Die Passwörter müssen identisch sein",
	"views.auth.request-new-password.backlogin": "Zurück zu Login",
	"views.auth.request-new-password.password": "Passwort zurücksetzen",
	"views.auth.request-new-password.title": "Passwort zurücksetzen",
	"views.auth.reset-password.backlogin": "Zurück zu Login",
	"views.auth.reset-password.loginsystem": "Im System anmelden",
	"views.auth.reset-password.reset": "Passwort zurücksetzen",
	"views.auth.reset-password.success": "Passwort zurücksetzen erfolgreich!",
	"views.auth.setup.account-configured-ready-to-use": "Hurra!! Ihr Konto ist konfiguriert und einsatzbereit!",
	"views.auth.setup.add-users-to-organization": "Benutzer zu Ihrer Organisation hinzufügen",
	"views.auth.setup.back": "Zurück zum Login",
	"views.auth.setup.click-to-go-user-console": "Klicken Sie hier, um zur Benutzerkonsole zu gelangen",
	"views.auth.setup.code": "Geben Sie den Code ein, welchen Sie per E-Mail erhalten haben",
	"views.auth.setup.code-sent-to-email": "Neuer Code wurde gesendet an {email}",
	"views.auth.setup.code.check-email": "Überprüfen Sie Ihre E-Mail",
	"views.auth.setup.code.failed": "Der Code ist falsch. Überprüfen Sie ihn oder ",
	"views.auth.setup.code.failed.new-code": "fordern Sie einen neuen Code an.",
	"views.auth.setup.code.get-new-code": "Erhalte einen neuen Code",
	"views.auth.setup.code.introduction": "Wir haben Ihnen einen Bestätigungscode an {email} gesendet.",
	"views.auth.setup.code.introduction-to-enter": "Bitte geben Sie ihn unten ein, um Ihre E-Mail-Adresse zu bestätigen.",
	"views.auth.setup.code.introduction.without-email": "Wir haben Ihnen einen Bestätigungscode gesendet.",
	"views.auth.setup.contacts": "Wählen Sie die Kontakte Ihrer Organisation",
	"views.auth.setup.continue": "Weiter",
	"views.auth.setup.create-password": "Erstellen Sie ein Passwort zur sicheren Anmeldung",
	"views.auth.setup.failed-requesting-new-code": "Wir konnten den Code nicht an {email} senden. Bitte kontaktieren Sie contact{'@'}siemens.com",
	"views.auth.setup.failed-saving-user": "Speichern fehlgeschlagen: {user}",
	"views.auth.setup.inform-valid-email": "Geben Sie eine gültige E-Mail Adresse ein",
	"views.auth.setup.inform-valid-name": "Namen eingeben",
	"views.auth.setup.is-user-admin": "Is Organization Admin?",
	"views.auth.setup.organization": "Weitere Informationen zur Organisation",
	"views.auth.setup.organization-name": "Name der Organisation",
	"views.auth.setup.request-new-code": "Haben Sie den Code nicht erhalten oder ist er abgelaufen? Klicken Sie hier, um einen neuen zu erhalten!",
	"views.auth.setup.skip": "Überspringen",
	"views.auth.setup.try-again": "Oops! Bitte versuchen Sie es erneut",
	"views.auth.setup.user-name": "Vollständiger Name",
	"views.auth.setup.user-remove": "Löschen",
	"views.auth.setup.users-saved": "Benutzer erstellt",
	"views.auth.username.password.failed-title": "Ein Fehler ist aufgetreten",
	"views.box-list-map.box-list-map.failed-getting-devices": "Fehler beim Abrufen der Liste von @.lower:boxes",
	"views.box-list-map.components.map.location": "Standort festlegen/ändern",
	"views.box-list-map.components.map.zoom": "Fokus",
	"views.box-list-map.components.search-address.address-not-found": "Addresse nicht gefunden",
	"views.box-list.box-list.failed-get-box-list": "Die Liste von @.lower:boxes konnte nicht abgerufen werden.",
	"views.box-list.box-list.failed-get-box-location": "Abfrage des @.lower:{'box'}-Standorts fehlgeschlagen.",
	"views.box-list.box-list.failed-get-search-location": "Suche konnte nicht ermittelt werden.",
	"views.box-list.box-list.search": "Standort suchen...",
	"views.box-list.box-list.search-for-box": "Suche nach @.lower:box (Name, Geräte Id oder Hardware Id)",
	"views.box-list.components.dialog-active-box.box-plan-addonsmax": "Addons: ",
	"views.box-list.components.dialog-active-box.box-plan-datapoints": "Max Datenpunkte: ",
	"views.box-list.components.dialog-active-box.box-plan-properties": "inkl. Datenpunkte: ",
	"views.box-list.components.inactive-device.inactive-box": "Inactive @.lower:box",
	"views.box.box.failed-get-box-info": "Failed getting @.lower:box information",
	"views.box.components.box-nav.box-nav.configuration": "Konfiguration",
	"views.box.components.box-nav.box-nav.graph": "Diagramm",
	"views.box.components.box-nav.box-nav.logs": "Logbuch",
	"views.box.components.dialog-edit-box-geolocation.dialog-edit-box-geolocation.box-geolocation-changed": "@.capitalize:box geografischer Standort geändert",
	"views.box.components.dialog-edit-box-geolocation.dialog-edit-box-geolocation.failed-saving-new-geolocation": "Failed saving new geographic location",
	"views.box.components.dialog-edit-box-name.dialog-edit-box-name.box-name-changed": "@.capitalize:box name changed",
	"views.box.old-config": "Ihre @.lower:box ist nicht mehr aktuell. Bitte setzen Sie sich mit dem Hersteller in Verbindung, um Ihre @.lower:box zu aktualisieren.",
	"views.box.views.configuration.components.footer-buttons.cancel-sent-changes": "Revert sent changes",
	"views.box.views.configuration.components.footer-buttons.cant-send-configuration-box-not-online": "Not allowed to send configuration to the @.lower:box because it's not online",
	"views.box.views.configuration.components.footer-buttons.failed-getting-command-details": "Failed getting command details",
	"views.box.views.configuration.components.footer-buttons.failed-getting-device-information": "Failed getting @.lower:box status",
	"views.box.views.configuration.components.footer-buttons.failed-reverting-changes": "Failed reverting changes",
	"views.box.views.configuration.components.footer-buttons.failed-saving-configuration": "Failed sending the configuration to the @.lower:box",
	"views.box.views.configuration.components.footer-buttons.message-revert-sent-changes": "Cancel sent changes (they were not applied to the @.lower:box yet)?",
	"views.box.views.configuration.components.footer-buttons.new-configuration-in-box": "The new configuration is in the @.lower:{'box'}!",
	"views.box.views.configuration.components.modal-publish-draft.comment": "Write a comment about this new setting being sent to the @.lower:box",
	"views.box.views.configuration.components.modal-publish-draft.placehoder": "A description of this revision. Useful for listing the changes that was made in this revision.",
	"views.box.views.configuration.components.modal-publish-draft.send-to-box": "Senden an @.lower:box",
	"views.box.views.configuration.components.modal-publish-draft.title": "Konfiguration an @.lower:box senden",
	"views.box.views.configuration.components.tabs.connectors": "Anschlüsse",
	"views.box.views.configuration.components.tabs.equipment": "Geräte",
	"views.box.views.configuration.components.tabs.gateways": "Gateways",
	"views.box.views.configuration.components.tabs.networks": "Netzwerke",
	"views.box.views.configuration.views.connectors.components.panel-connector.tooltip-ipv4-method": "The type of IP configuration: manual for manually specifying the IP, or DHCP",
	"views.box.views.configuration.views.connectors.connectors-list.failed-adding-new-connector-to-draft": "Failed saving connector {connector} to Draft configuration",
	"views.box.views.configuration.views.connectors.connectors-list.failed-get-draft-current-config": "Failed getting connector from Current/Draft configuration",
	"views.box.views.configuration.views.equipment.components.modal-duplicate-equipment.duplicate-to-box": "Duplicate to @.lower:box",
	"views.box.views.configuration.views.equipment.components.modal-duplicate-equipment.select-box-to-duplicate": "Select the @.lower:box you want to duplicate this equipment",
	"views.box.views.configuration.views.equipment.components.modal-duplicate-equipment.to-which-box-duplicate": "To which @.lower:box would you like to duplicate?",
	"views.box.views.configuration.views.equipment.components.modal-duplicate-equipment.to-which-network-add-box": "To which network would you like to add the duplicated @.lower:{'box'}?",
	"views.box.views.configuration.views.equipment.components.panel-equipment.device-identifier": "Unique Device Identifier provided by manufactuter",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups": "Equipment groups",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.add": "Gruppe hinzufügen",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.all": "Alle Geräte",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.group-name": "Gruppenname",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.group-name-mandatory": "Group name is mandatory.",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.hint": "To move equipment to a group, click the dropdown menu on the right",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.no-equipment": "No equipment here",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.ungrouped": "keine Gruppe",
	"views.box.views.configuration.views.equipment.equipment-list.ask-delete-this-equipment": "Sind Sie sicher, dass Sie dieses Gerät löschen möchten?",
	"views.box.views.configuration.views.equipment.equipment-list.equipment-network-updated": "Geräte Netzwerk aktualisiert",
	"views.box.views.configuration.views.equipment.equipment-list.equipment-saved": "Gerät gespeichert",
	"views.box.views.configuration.views.equipment.equipment-list.failed-get-draft-current-config": "Failed getting equipment from Current/Draft configuration",
	"views.box.views.configuration.views.equipment.equipment-list.failed-updating-equipment": "Update Gerät fehlgeschlagen",
	"views.box.views.configuration.views.equipment.equipment-list.failed-updating-network": "Failed updating Equipment's Network",
	"views.box.views.configuration.views.equipment.equipment-list.remember-send-to-box": "Remember to send to the @.lower:box",
	"views.box.views.configuration.views.equipment.equipment-list.scan-save-configuration": "In order to use this network in the Scan, you have to send the configuration to the @.lower:box",
	"views.box.views.configuration.views.gateways.failed-get-draft-current-config": "Failed getting current/draft configuration for Gateways",
	"views.box.views.configuration.views.gateways.gateway-deleted": "Gateway gelöscht",
	"views.box.views.configuration.views.networks.components.connector.baudrate": "Baudrate",
	"views.box.views.configuration.views.networks.components.connector.data-bits": "Data bits",
	"views.box.views.configuration.views.networks.components.connector.failed-getting-infos-from-connector": "Failed getting information from connector",
	"views.box.views.configuration.views.networks.components.connector.parity": "Parität",
	"views.box.views.configuration.views.networks.components.connector.stop-bits": "Stop bits",
	"views.box.views.configuration.views.networks.components.connector.you-have-to-select-field": "You have to select a {field}",
	"views.box.views.configuration.views.networks.components.network-row.device-number": "Device number",
	"views.box.views.configuration.views.networks.components.network-row.segment-number": "Segment number",
	"views.box.views.configuration.views.networks.components.panel-network.device-instance": "@.capitalize:box device instance",
	"views.box.views.configuration.views.networks.components.panel-network.domain": "Domain",
	"views.box.views.configuration.views.networks.components.panel-network.failed-saving-network": "Failed saving network",
	"views.box.views.configuration.views.networks.components.panel-network.mode": "Mode",
	"views.box.views.configuration.views.networks.components.panel-network.mode-placeholder": "Select which mode this network will run in",
	"views.box.views.configuration.views.networks.components.panel-network.network-saved": "Network saved",
	"views.box.views.configuration.views.networks.components.panel-network.node": "Knoten",
	"views.box.views.configuration.views.networks.components.panel-network.placeholder-device-instance": "A device instance for this network. This device instance has to be unique on the @.lower:{'box'}.",
	"views.box.views.configuration.views.networks.components.panel-network.placeholder-frequency": "Select the frequency",
	"views.box.views.configuration.views.networks.components.panel-network.subnet": "Subnet",
	"views.box.views.configuration.views.networks.components.panel-network.timeout": "Timeout",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-device-number": "The device number of the @.lower:box itself",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-domain": "The domain of the @.lower:box on the LON IP network",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-individual-address": "The individual address of the @.lower:{'box'}. In the format A.L.D, ex: 1.2.3",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-internal-address": "The addresses used internally on the @.lower:{'box'}. In the format A.L.D; ex: 1.2.3",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-node": "The node of the @.lower:box on the LON IP network",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-placeholder-frequency": "Select the frequency the LoRa equipment will be installed.",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-placeholder-region": "Select the region the LoRa equipment will be installed.",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-port": "The port on which this network will listen",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-segment-number": "The segment number of the @.lower:box itself",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-subnet": "The sub-net of the @.lower:box on the LON IP network",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-timeout": "Maximum time for the request for processing in ms",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-udp-port": "Expected UDP port. This value is unique for a specific physical connector.",
	"views.box.views.configuration.views.networks.network-list.failed-deleting-network": "Failed deleting network",
	"views.box.views.configuration.views.networks.network-list.failed-get-draft-current-config": "Failed getting equipment from Current/Draft configuration",
	"views.box.views.configuration.views.networks.network-list.network-deleted": "Netzwerk entfernt",
	"views.box.views.configuration.views.networks.network-list.search-network": "nach Netzwerk suchen",
	"views.box.views.configuration.views.notifications.alarm-deleted": "Event notification deleted",
	"views.box.views.configuration.views.notifications.components.form-recipient.recipient-type": "Empfängerart",
	"views.box.views.configuration.views.notifications.components.form-recipient.recipient-type-tooltip": "Where the recipient will receive the alarm? By E-mail or in a Slack channel?",
	"views.box.views.configuration.views.notifications.components.panel-alarm.failed-saving": "Failed saving event notification",
	"views.box.views.configuration.views.notifications.components.panel-alarm.recipient": "Empfänger",
	"views.box.views.configuration.views.notifications.components.panel-alarm.recipient-tooltip": "Wohin/an wen wird der Alarm gesendet?",
	"views.box.views.configuration.views.notifications.components.panel-alarm.saved": "Event notification saved with success",
	"views.box.views.configuration.views.notifications.components.panel-alarm.title": "Configure Event Notification",
	"views.box.views.configuration.views.notifications.components.panel-alarm.type": "Ereignistyp",
	"views.box.views.configuration.views.notifications.components.panel-alarm.type-tooltip": "Type of event: when @.lower:box connects or disconnects",
	"views.box.views.configuration.views.notifications.create-new-recipient": "neuen Empfänger erstellen",
	"views.box.views.configuration.views.notifications.failed-deleting-alarm": "Failed deleting event notification",
	"views.box.views.configuration.views.notifications.failed-getting-recipients": "Empfänger nicht gefunden",
	"views.box.views.configuration.views.properties.components.panel-knx.tooltip-data-point-type": "The KNX datapoint type identifier in the format \"xx.yyyy\", where: xx: The main number; yyyy: The subnumber",
	"views.box.views.configuration.views.properties.components.panel-knx.tooltip-group-address": "The 3-level group address where to access to this property. Format \"xxx/yyy/zzz\", where: xxx: the main group; yyy: the middle group; zzz: the subgroup",
	"views.box.views.configuration.views.properties.components.panel-knx.tooltip-object-index": "The object index of the property to read",
	"views.box.views.configuration.views.properties.components.panel-knx.tooltip-property-index": "The datapoint index of the datapoint to read",
	"views.box.views.configuration.views.properties.components.panel-knx.tooltip-start-index": "The start index of the datapoint to read",
	"views.box.views.configuration.views.properties.components.panels.failed-slug": "Failed creating slug. Try changing the name of the datapoint (removing special characters) or contact us.",
	"views.box.views.configuration.views.properties.components.panels.timer_error": "Interval should be bigger than {seconds} seconds",
	"views.box.views.configuration.views.properties.components.panels.title": "Datenpunkt {title}",
	"views.box.views.configuration.views.properties.components.panels.tooltip-unit": "The engineering unit of this datapoint.",
	"views.box.views.configuration.views.properties.failed-information-equipment": "Failed getting information from the Equipment",
	"views.box.views.configuration.views.properties.properties.alert-send-configuration.send-configuration": "Send the configuration to the @.lower:box to apply the changes in datapoints",
	"views.box.views.configuration.views.properties.properties.alert-send-configuration.show-less": "Click to show less",
	"views.box.views.configuration.views.properties.properties.alert-send-configuration.show-more": "Click to show more",
	"views.box.views.configuration.views.properties.properties.list-properties": "List of datapoints for {equipment}",
	"views.box.views.configuration.views.properties.properties.slug-duplicated-error": "The slug for the property is already being used. Change it, please (you'll find it in Advanced)",
	"views.box.views.graph.graph.export": "Export",
	"views.box.views.graph.graph.select-least-one-property": "Select at least one datapoint from the list below",
	"views.box.views.graph.graph.select-range": "Select date range",
	"views.box.views.logs.components.tabs.commands": "Befehle",
	"views.box.views.logs.components.tabs.events": "Ereignisse",
	"views.box.views.logs.modal-commands-details.body": "Body",
	"views.box.views.logs.modal-commands-details.commandid": "Command ID",
	"views.box.views.logs.modal-commands-details.commandtype": "Typ",
	"views.box.views.logs.modal-commands-details.createdby": "Created By",
	"views.box.views.logs.modal-commands-details.date": "Datum",
	"views.box.views.logs.modal-commands-details.deviceid": "Device ID",
	"views.box.views.logs.modal-commands-details.last": "Letztes Update",
	"views.box.views.logs.modal-commands-details.retry": "Anzahl der Wiederholungen",
	"views.box.views.logs.modal-commands-details.status": "Status",
	"views.box.views.logs.modal-events-details.code": "Code",
	"views.box.views.properties.views.properties.components.panel-set-value-to-property.last-value": "Last set value",
	"views.box.views.properties.views.properties.components.panel-set-value-to-property.new-value": "New Value",
	"views.box.views.properties.views.properties.components.panel-set-value-to-property.title": "Set value to property",
	"views.box.views.properties.views.properties.components.property-graph.no-available-properties": "No datapoint values to display",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.info-equipment": "I would like to request the equipment {equipment} to be added in the list.\tOther information:",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.inform-equipment-connect": "Please, inform us what’s the equipment (brand, model and other useful information) you want to connect to the @.lower:box",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.placeholder": "Brand, model and other useful information from equipment",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.problem-submiting-request": "There was a problem submitting the request. Try again later.",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.request": "Request",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.request-add-equipment": "Request to add an equipment",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.specify-equipment": "You have to specify which equipment you want us to add",
	"views.box.views.wizard-configuration.components.dialog-saving.add-another": "Weiteres Gerät hinzufügen",
	"views.box.views.wizard-configuration.components.dialog-saving.check-configuration": "Prüfe @.lower:box Konfiguration",
	"views.box.views.wizard-configuration.components.dialog-saving.hold-on": "Hold on there while we're saving!",
	"views.box.views.wizard-configuration.components.dialog-saving.problem-saving": "There was a problem saving! What do you want to do?",
	"views.box.views.wizard-configuration.components.dialog-saving.save": "Gespeichert!",
	"views.box.views.wizard-configuration.components.filters.all": "Alle",
	"views.box.views.wizard-configuration.components.filters.equipment": "Gerät",
	"views.box.views.wizard-configuration.components.properties-filters.read": "Read",
	"views.box.views.wizard-configuration.components.properties-filters.search-for-properties-or-equipment": "Search for datapoints or equipment",
	"views.box.views.wizard-configuration.components.properties-filters.write": "Write",
	"views.box.views.wizard-configuration.steps.configure-connector-ethernet.failed-get-network-config": "Failed getting network configuration",
	"views.box.views.wizard-configuration.steps.configure-connector-ethernet.went-wrong": "Something went wrong in our side. Try again.",
	"views.box.views.wizard-configuration.steps.configure-connector-ethernet.which-connector-plugged": "Which connector is your equipment plugged?",
	"views.box.views.wizard-configuration.steps.configure-connector-serial.connector-warning-message": "Be aware that changing this configuration will affect all other equipment plugged in this connector.",
	"views.box.views.wizard-configuration.steps.configure-network-knx.title": "Configure KNX addresses in the @.lower:box - KNX Network Configuration",
	"views.box.views.wizard-configuration.steps.select-equipment.ask-request-equipment": "We do not have this equipment yet. Would you like to request it?",
	"views.box.views.wizard-configuration.steps.select-equipment.field-required": "Field {fieldName} is required",
	"views.box.views.wizard-configuration.steps.select-equipment.field-validation": "Field {fieldName} should be between {validationmin} and {validationmax}",
	"views.box.views.wizard-configuration.steps.select-equipment.number-required": "Field {fieldName} must be a number",
	"views.box.views.wizard-configuration.steps.select-equipment.request-it": "Request it",
	"views.box.views.wizard-configuration.steps.select-equipment.search-brand-model": "Sie können nach dem Hersteller oder Gerätetyp suchen",
	"views.box.views.wizard-configuration.steps.select-equipment.select-protocol": "Wie lautet das Kommunikationsprotokoll für das Gerät?",
	"views.box.views.wizard-configuration.wizard-configuration.send-to-box": "Send to the @.lower:box",
	"views.file-resources-management.edit-file": "Datei bearbeiten",
	"views.file-resources-management.failed-getting-files": "Abrufen der Dateiliste fehlgeschlagen",
	"views.file-resources-management.failed-uploading-file": "Hochladen der Datei fehlgeschlagen",
	"views.file-resources-management.last-modified": "letzte Änderung",
	"views.file-resources-management.title": "Dateiverwaltung",
	"views.file-resources-management.upload-new-file": "Neue Datei hochladen",
	"views.organization.access-management.roles.administrative": "Administrative Verwaltung",
	"views.organization.access-management.roles.administrative-description": "Verwalten von Organisationen, Sub-Organisationen",
	"views.organization.access-management.roles.alarm-access": "Verwaltung von Warnungen",
	"views.organization.access-management.roles.boxes-access": "Zugang zu den @.lower:boxes",
	"views.organization.access-management.roles.boxes-access-description": "Data, Tags, Connector, Alarms",
	"views.organization.access-management.roles.boxes-management": "Verwaltung von @.lower:boxes",
	"views.organization.access-management.roles.boxes-management-description": "Aktivierung und Konfiguration der @.lower:boxes",
	"views.organization.access-management.roles.connectors-configuration": "Konfiguration der Anschlüsse",
	"views.organization.access-management.roles.connectors-configuration-description": "MQTT, Webhooks, Slack Channels, Service Accounts (API Schlüssel)",
	"views.organization.access-management.roles.metadata-configuration": "Verwaltung der Metadaten",
	"views.organization.access-management.roles.metadata-configuration-description": "Sites, Geräte Gruppen",
	"views.organization.access-management.roles.users-management": "Benutzerverwaltung",
	"views.organization.components.notifications.form-email.email": "E-Mail",
	"views.organization.components.notifications.form-slack.channel": "Kanal",
	"views.organization.components.notifications.form-slack.url": "Slack API URL",
	"views.organization.components.notifications.form-slack.username": "Benutzername",
	"views.organization.components.service-accounts.list-api-keys.add-a-p-i-key": "API Schlüssel hinzufügen",
	"views.organization.components.service-accounts.list-api-keys.api-key-deleted": "API Schlüssel gelöscht",
	"views.organization.components.service-accounts.list-api-keys.api-keys": "API Schlüssel",
	"views.organization.components.service-accounts.list-api-keys.failed-deleting-a-p-i-key": "Löschen des API Schlüssels fehlgeschlagen",
	"views.organization.components.service-accounts.list-api-keys.key": "Schlüssel",
	"views.organization.components.service-accounts.list-api-keys.secret": "Secret",
	"views.organization.components.service-accounts.panel-create-api-key.advanced-options": "Erweiterte Einstellungen",
	"views.organization.components.service-accounts.panel-create-api-key.api-key-created": "API Schlüssel erstellt",
	"views.organization.components.service-accounts.panel-create-api-key.create-api-key": "API Schlüssel erstellen",
	"views.organization.components.service-accounts.panel-create-api-key.description": "Beschreibung",
	"views.organization.components.service-accounts.panel-create-api-key.download-a-p-i-key": "API Schlüssel herunterladen",
	"views.organization.components.service-accounts.panel-create-api-key.expire-date": "Ablauf Datum",
	"views.organization.components.service-accounts.panel-create-api-key.expire-in-hours": "Ablauf in Stunden",
	"views.organization.components.service-accounts.panel-create-api-key.failed-creating-a-new-api-key": "Erstellung eines neuen API-Schlüssels fehlgeschlagen",
	"views.organization.components.service-accounts.panel-create-api-key.field-expire-in-hours-must-be-a-number->-1": "Das Feld -Ablauf in Stunden- muss eine Zahl > 1 sein.",
	"views.organization.components.service-accounts.panel-create-api-key.key": "Schlüssel",
	"views.organization.components.service-accounts.panel-create-api-key.save-key-message": "Bitte bewahren Sie den geheimen Schlüssel an einem sicheren Ort auf. Wenn Sie diesen verloren haben, können Sie ihn nicht wiedererlangen!",
	"views.organization.components.service-accounts.panel-create-api-key.secret": "Secret",
	"views.organization.components.service-accounts.panel-create-api-key.tooltip-expire-hours": "In wie vielen Stunden nach der Erstellung sollte dieser API-Schlüssel ablaufen?",
	"views.organization.components.service-accounts.panel-create-service-account.create-service-account": "Service Account erstellen",
	"views.organization.components.service-accounts.panel-create-service-account.error-prefix": "Feld -Präfix- sollte nur alphanumerische Zeichen mit optionalen Bindestrichen enthalten",
	"views.organization.components.service-accounts.panel-create-service-account.failed-creating-service-account": "Erstellung eines neuen Service Accounts fehlgeschlagen",
	"views.organization.components.service-accounts.panel-create-service-account.password": "Passwort",
	"views.organization.components.service-accounts.panel-create-service-account.prefix": "Prefix",
	"views.organization.components.service-accounts.panel-create-service-account.service-account-created": "Service Account erstellt",
	"views.organization.components.service-accounts.panel-create-service-account.tooltip-password": "Das Passwort für die Anmeldung mit diesem Service Account",
	"views.organization.components.service-accounts.panel-create-service-account.tooltip-prefix": "Ein Präfix wurde am Anfang des Benutzernamens des Dienstkontos verwendet. Dieses Präfix muss eindeutig sein. Der resultierende Dienstkonto-Benutzername hat die Form prefix{'@'}organizationId.svc.acct.wattsense.com",
	"views.organization.components.service-accounts.service-accounts-list.prefix": "Präfix",
	"views.organization.components.service-accounts.service-accounts-list.qtt-apikeys": "API Schlüssel",
	"views.user-profile.profile.language": "Sprache",
	"views.user-profile.profile.name": "Name",
	"views.user-profile.profile.newpassword": "Neues Passwort",
	"virtual-properties.calculate-consumption": "Verbrauch berechnen",
	"virtual-properties.checkbox-create-another-property-after-save": "Create another virtual property after this one",
	"virtual-properties.consumption-interval": "Wie groß ist das Verbrauchsinterval?",
	"virtual-properties.consumption-interval-tooltip": "Der Verbrauch wird für jedes Intervall nach folgender Formel berechnet: Differenz zwischen dem letzten bekannten Datenpunktwert während des Intervalls und dem ersten bekannten Wert während desselben Intervalls.",
	"virtual-properties.create-virtual-property": "Virtuellen Datenpunkt erstellen",
	"virtual-properties.data-transmition-frequency-interval-label": "Häufigkeit oder Intervall der Datenübertragung:",
	"virtual-properties.edit-virtual-property": "Virtuellen Datenpunkt editieren",
	"virtual-properties.failed-deleting-property": "Löschen des virtuellen Datenpunkt fehlgeschlagen",
	"virtual-properties.failed-saving": "Speichern des virtuellen Datenpunktes fehlgeschlagen",
	"virtual-properties.failed-saving-property": "Erstellung eines virtuellen Datenpunktes fehlgeschlagen",
	"virtual-properties.failed-updating-property": "Aktualisieren eines virtuellen Datenpunktes fehlgeschlagen",
	"virtual-properties.last-value-label": "Letzter Wert:",
	"virtual-properties.other-calculation": "Andere Berechnungen",
	"virtual-properties.property-created": "Virtuellen Datenpunk erstellt",
	"virtual-properties.property-deleted": "Virtuellen Datenpunk gelöscht",
	"virtual-properties.property-updated": "Virtuellen Datenpunk aktualisiert",
	"virtual-properties.property-value": "Datenpunktwert",
	"virtual-properties.received-at-label": "Empfangen:",
	"virtual-properties.search-by-name": "Suche nach Name",
	"virtual-properties.select-properties-tooltip": "Der Verbrauch wird auf der Grundlage des gewählten Datenpunktes berechnet.",
	"virtual-properties.text-empty-state": "Erstellen Sie neue Datenpunkte, die aus vorhandenen Datenpunkten berechnet werden. Zur Zeit nur für die Berechnung des Verbrauchs verfügbar.",
	"virtual-properties.virtual-properties": "Virtuelle Datenpunkte",
	"virtual-properties.what-would-you-like-to-do": "What would you like to do?",
	"virtual-property-cant-refresh": "Virtual property values are updated automatically. They cannot be refreshed manually.",
	"virtual-property-created-but-not-activated-yet-go-to-configuration-and-save": "The virtual property is created, but it is not activated yet. Go to the “Configuration” screen and click on “Save changes” to apply it.",
	"virtual-property.scaling-message-property-with-scaling": "Die auf diesen Datenpunkt angewandte Skalierung wird bei der Berechnung der virtuellen Eigenschaft nicht berücksichtigt.",
	"wait": "Warten Sie",
	"wait-until-receive-last-scan": "Warten Sie, bis Sie den letzten Scan empfangen haben",
	"waiting-for-scan": "Warten auf Scan",
	"waiting-for-the-hub": "Warten auf den @.lower:hub",
	"warning-message-gms-provider": "Unser GSM-Provider hat aktuell Probleme. Es kann zu Verlusten oder Verzögerungen bei der Kommunikation mit der Cloud kommen.",
	"was-not-received-by-box": "wurde nicht von der @.lower:box empfangen",
	"wattsense-headquarter": "Wattsense Headquarter",
	"we-will-try-for-another": "Wir werden einen weiteren Versuch unternehmen",
	"webhooks": "Webhooks",
	"wednesday": "Mittwoch",
	"week": "Woche",
	"weekday": "Wochentag",
	"weekly": "Wöchentlich",
	"welcome": "Willkommen",
	"what-configuration-from-equipment-for-box-communicate-with-it": "Wie muss das Gerät konfiguriert sein, damit @.lower:box mit ihm kommunizieren kann?",
	"what-do-you-want-to-do-next": "Was wollen Sie als nächstes tun?",
	"what-would-like-to-do-next": "Was wollen Sie als nächstes tun?",
	"when-it-ends": "When it ends?",
	"which-connector-equipment-is-plugged": "Mit welchem Anschluss ist ihr Gerät verbunden?",
	"windows": "Windows",
	"windows-instructions": "Windows-Anweisungen",
	"wmbus-dib": "Concatenated DIFs & DIFEs",
	"wmbus-physical-connector": "LoRaWAN radio antenna",
	"wmbus-vib": "Concatenated VIFs & VIFEs",
	"write": "Write",
	"write-function": "Write function",
	"write-only": "Write Only",
	"write-only-desc": "Werte nur aus der Cloud schreiben lassen (nur schreiben)",
	"wrong-file-format": "Datei im falschen Format",
	"wrong-file-header": "Datei-Header im falschen Format",
	"ws-data-table.no-records-to-display": "Keine Datensätze zum Anzeigen",
	"ws-data-table.rows-of-page-are-selected": "1 row is selected in total. | {qtt} rows are selected in total.",
	"ws-data-table.select-all-available-rows": "Select all available rows. | Select all available rows ({qtt})",
	"ws-form-treeselect.no-results": "No results",
	"x-years": "years | year | years",
	"y-axis": "Y Achse",
	"year": "Jahr",
	"yearly": "Jährlich",
	"yes": "Ja",
	"you-can-upload-a-file-clicking-here": "Sie können die Datei hochladen {0}",
	"you-dont-have-access-to-organization": "You don't have access to organization",
	"you-dont-have-tags": "Sie haben keine Markierungen.",
	"your-equipment": "Your equipment",
	"zero-organizations-found-with-term": "0 Organisationen mit der Bezeichnung {term} gefunden"
}